// Containers
const TheContainer = () => import("@/containers");

const Home = () => import("@/views/HomePage");
const About = () => import("@/views/About");
const Login = () => import("@/views/Login");

const Profile = () => import("@/views/Profile");
const UpdateProfile = () => import("@/views/Profile/update");
const ChangePasswordProfile = () => import("@/views/Profile/change_password");

const UserManagement = () => import("@/views/UserManagement");
const CreateUserManagement = () => import("@/views/UserManagement/create");
const DetailUserManagement = () =>
  import("@/views/UserManagement/Detail/index");
const ReportingUserManagement = () =>
  import("@/views/UserManagement/reporting");

const POStatus = () => import("@/views/POStatus");
const POStatusDetail = () => import("@/views/POStatus/Detail");
const PhotosPoolingSpektra = () => import("@/views/POStatus/PhotosPooling");
const POStatusArchive = () => import("@/views/POStatus/Archive");
const POStatusArchiveDetail = () => import("@/views/POStatus/Archive/Detail");

const POStatusNMC = () => import("@/views/MasterNonSpektra/POStatus");
const POStatusNMCDetail = () =>
  import("@/views/MasterNonSpektra/POStatus/Detail");
const PhotosScreeningNmc = () =>
  import("@/views/MasterNonSpektra/POStatus/PhotosScreening");

const POStatusNMCArchive = () =>
  import("@/views/MasterNonSpektra/POStatus/Archive");
const POStatusNMCArchiveDetail = () =>
  import("@/views/MasterNonSpektra/POStatus/Archive/Detail");

const Roles = () => import("@/views/Roles");
const AddRoles = () => import("@/views/Roles/create");
const DetailRoles = () => import("@/views/Roles/Detail");
const RestrictionExport = () =>
  import("@/views/Roles/Detail/RestrictionExport/create");

const ReportingCardDistribution = () =>
  import("@/views/CardDistribution/Reporting");

const CardVerification = () =>
  import("@/views/CardDistribution/CardVerification/index");
const CardVerificationDetail = () =>
  import("@/views/CardDistribution/CardVerification/Detail");
const CardVerificationManualCheck = () =>
  import("@/views/CardDistribution/CardVerification/Detail/ManualCheck");
const CardStock = () => import("@/views/CardDistribution/CardStock/index");
const CardStockDetail = () =>
  import("@/views/CardDistribution/CardStock/detail");

const CardAssignment = () => import("@/views/CardDistribution/CardAssignment");
const CardAssignmentDetail = () =>
  import("@/views/CardDistribution/CardAssignment/detail");
const CardAssignmentCardListDetail = () =>
  import("@/views/CardDistribution/CardAssignment/Detail/CardList/Detail");
const CardAssignmentCreate = () =>
  import("@/views/CardDistribution/CardAssignment/Create");
const CardAssignmentSearchResult = () =>
  import("@/views/CardDistribution/CardAssignment/Search");

const CardPickUp = () => import("@/views/CardDistribution/CardPickup");
const CardPickUpDetail = () =>
  import("@/views/CardDistribution/CardPickup/Detail");
const CardPickUpCreate = () =>
  import("@/views/CardDistribution/CardPickup/Add");

const CardSources = () => import("@/views/CardSources");
const CardSourcesCreate = () => import("@/views/CardSources/Create");
const CardSourcesDetail = () => import("@/views/CardSources/Detail");

const CardIssuance = () => import("@/views/CardIssuance");
const CardIssuanceDetail = () => import("@/views/CardIssuance/detail");
const CardListDetail = () => import("@/views/CardList/detail");
const DeliveryListDetail = () => import("@/views/DeliveryList/detail");
const DeliveryCardList = () => import("@/views/DeliveryList/card-list");
const CustomerDeliver = () => import("@/views/CardIssuance/Deliver/customer");
const BranchDeliver = () => import("@/views/CardIssuance/Deliver/branch");
const UploadReceipt = () => import("@/views/UploadReceipt");

const CardNoGeneratorSetup = () => import("@/views/CardNoGenerator/index");
const CardGeneratorBranch = () =>
  import("@/views/CardNoGenerator/Deliver/branch");
const CardGeneratorCustomer = () =>
  import("@/views/CardNoGenerator/Deliver/customer");

const CardNoReservationsList = () => import("@/views/CardNoReservation");
const CardNoReservationAdd = () => import("@/views/CardNoReservation/Add");
const CardNoReservationImport = () =>
  import("@/views/CardNoReservation/Import");
const CardNoReservationDetail = () =>
  import("@/views/CardNoReservation/Detail");
const CardNoReservationSelection = () =>
  import("@/views/CardNoReservation/SelectForIssuance/index");
const BranchSelection = () =>
  import(
    "@/views/CardNoReservation/SelectForIssuance/SearchBy/Sequence/BranchSelection/index"
  );

const CardLost = () => import("@/views/CardLost");
const CardLostCreate = () => import("@/views/CardLost/Add");
const CardLostDetail = () => import("@/views/CardLost/Detail");
const ReportingCardLost = () => import("@/views/CardLost/reporting");

const eCardPrinting = () => import("@/views/eCardPrinting");
const eCardSelectForPrinting = () =>
  import("@/views/eCardPrinting/RequestToPrint");
const eCardDeliverCustomer = () =>
  import("@/views/eCardPrinting/DeliverToCustomer");

const CardTracking = () => import("@/views/CardTracking");
const CardTrackingDetail = () => import("@/views/CardTracking/detail");
const CardTrackingList = () => import("@/views/CardTracking/list");

const Master = () => import("@/views/Master");
const MasterBanner = () => import("@/views/Master/Banner");
const MasterBannerCreate = () => import("@/views/Master/Banner/create");
const MasterBannerDetail = () => import("@/views/Master/Banner/detail");
const ReportingMaster = () => import("@/views/Master/reporting");
const MasterBranch = () => import("@/views/Master/Branch/index");
const MasterBranchDetail = () => import("@/views/Master/Branch/detail");
const MasterBranchCreate = () => import("@/views/Master/Branch/create");
const MasterZipCode = () => import("@/views/Master/ZipCode");
const MasterZipCodeCreate = () => import("@/views/Master/ZipCode/create");
const MasterZipCodeDetail = () => import("@/views/Master/ZipCode/detail");
const MasterZipCodeImport = () => import("@/views/Master/ZipCode/import");
const MasterMRA = () => import("@/views/Master/MRA");
const MasterMRACreate = () => import("@/views/Master/MRA/create");
const MasterMRADetail = () => import("@/views/Master/MRA/detail");
const MasterMRO = () => import("@/views/Master/MRO");
const MasterMROCreate = () => import("@/views/Master/MRO/create");
const MasterMRODetail = () => import("@/views/Master/MRO/detail");
const MasterReasonUpdate = () => import("@/views/Master/ReasonMenu");
const MasterReasonUpdateCreate = () =>
  import("@/views/Master/ReasonMenu/create");
const MasterReasonUpdateDetail = () =>
  import("@/views/Master/ReasonMenu/detail");
const MasterReasonForLoss = () => import("@/views/Master/ReasonForLoss");
const MasterReasonForLossCreate = () =>
  import("@/views/Master/ReasonForLoss/create");
const MasterReasonForLossDetail = () =>
  import("@/views/Master/ReasonForLoss/detail");
const MasterReasonForExtension = () =>
  import("@/views/Master/ReasonsForExtension");
const MasterReasonForExtensionCreate = () =>
  import("@/views/Master/ReasonsForExtension/create");
const MasterTiering = () => import("@/views/MasterTieringPlafond");
const MasterTieringCreate = () => import("@/views/MasterTieringPlafond/create");
const MasterTieringDetail = () => import("@/views/MasterTieringPlafond/detail");

const MasterTokenAPI = () => import("@/views/MasterTokenAPI");
const MasterTokenAPICreate = () => import("@/views/MasterTokenAPI/create");
const MasterTokenAPIDetail = () => import("@/views/MasterTokenAPI/detail");

const MasterPromoNMC = () => import("@/views/MasterNonSpektra/Promo");
const MasterPromoNMCUpdate = () =>
  import("@/views/MasterNonSpektra/Promo/update");
const MasterPromoNMCImport = () =>
  import("@/views/MasterNonSpektra/Promo/Detail/Rates/import");
const MasterPromoNMCRatesUpdate = () =>
  import("@/views/MasterNonSpektra/Promo/Detail/Rates/update");
const MasterPromoNMCDetail = () =>
  import("@/views/MasterNonSpektra/Promo/Detail/index");
const MasterDealerNMCSF = () => import("@/views/MasterNonSpektra/DealerSf");
const MasterDealerNMCSFImport = () =>
  import("@/views/MasterNonSpektra/DealerSf/import");
const MasterDealerNMC = () => import("@/views/MasterNonSpektra/Dealer");
const MasterDealerNMCCreate = () =>
  import("@/views/MasterNonSpektra/Dealer/create");
const MasterDealerNMCDetail = () =>
  import("@/views/MasterNonSpektra/Dealer/Detail");

const MasterExclusiveDealerAdmin = () =>
  import("@/views/MasterNonSpektra/ExclusiveDealerAdmin");
const MasterExclusiveDealerAdminDetail = () =>
  import("@/views/MasterNonSpektra/ExclusiveDealerAdmin/Detail");
const MasterCreateExclusiveDealerAdmin = () =>
  import("@/views/MasterNonSpektra/ExclusiveDealerAdmin/Create");
const MasterImportExclusiveDealerAdmin = () =>
  import("@/views/MasterNonSpektra/ExclusiveDealerAdmin/import");

const MasterExclusiveDealerRate = () =>
  import("@/views/MasterNonSpektra/ExclusiveDealerRate");
const MasterExclusiveDealerRateDetail = () =>
  import("@/views/MasterNonSpektra/ExclusiveDealerRate/Detail");
const MasterCreateExclusiveDealerRate = () =>
  import("@/views/MasterNonSpektra/ExclusiveDealerRate/Create");
const MasterImportExclusiveDealerRate = () =>
  import("@/views/MasterNonSpektra/ExclusiveDealerRate/import");

const MasterUpdateMarketingSchemeDealer = () =>
  import("@/views/MasterNonSpektra/Dealer/MarketingScheme/update.vue");

const MasterProductNMC = () => import("@/views/MasterNonSpektra/Product");
const MasterProductNMCUpdate = () =>
  import("@/views/MasterNonSpektra/Product/update");
const MasterProductNMCDetail = () =>
  import("@/views/MasterNonSpektra/Product/detail");

const MasterBranchNMC = () => import("@/views/MasterNonSpektra/Branch");
const MasterDetailBranchNMC = () =>
  import("@/views/MasterNonSpektra/Branch/Detail");
const MasterCreateBranchNMC = () =>
  import("@/views/MasterNonSpektra/Branch/create");
const MasterImportBranchNMC = () =>
  import("@/views/MasterNonSpektra/Branch/import");
const MasterImportBulkBranchNMC = () =>
  import("@/components/Default/importBulk");
const MasterNMCBranchRate = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Rate");
const MasterNMCCreateBranchRate = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Rate/create");
const MasterNMCDetailBranchRate = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Rate/detail");
const MasterCreateExclusiveRateBranchNMC = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/ExclusiveRate/create");
const NMCMasterBranchFee = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Fee");
const NMCMasterCreateBranchFee = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Fee/create");
const MasterNMCDetailBranchFee = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Fee/Detail");
const MasterNMCCreateBranchExclusive = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Fee/createExclusive");

const MasterBranchPromoNMC = () =>
  import("@/views/MasterNonSpektra/BranchPromoFee");
const MasterResetBranchPromoNMC = () =>
  import("@/views/MasterNonSpektra/BranchPromoFee/reset");
const MasterImportBulkBranchPromoNMC = () =>
  import("@/views/MasterNonSpektra/BranchPromoFee/importBulk");

const QanunBranch = () => import("@/views/QanunBranch");
const ImportQanunBranch = () => import("@/views/QanunBranch/import");
const CreateQanunBranch = () => import("@/views/QanunBranch/create");
const DetailQanunBranch = () => import("@/views/QanunBranch/Detail");

const MasterInsuranceNMC = () =>
  import("@/views/MasterNonSpektra/MasterInsurance/index");
const MasterInsuranceNMCDetail = () =>
  import("@/views/MasterNonSpektra/MasterInsurance/Detail/index");

const ProductInsuranceNMC = () => import("@/views/MasterNonSpektra/Insurance");
const ProductInsuranceNMCDetail = () =>
  import("@/views/MasterNonSpektra/Insurance/Detail");

const ProgramType = () => import("@/views/ProgramType");
const ProgramTypeCreate = () => import("@/views/ProgramType/create");
const ProgramTypeDetail = () => import("@/views/ProgramType/detail");

const Promo = () => import("@/views/Promo");
const PromoDetail = () => import("@/views/Promo/Detail");
const PromoUpdate = () => import("@/views/Promo/update");
const ReportingPromo = () => import("@/views/Promo/reporting");
const UpdateBulkPromo = () => import("@/views/Promo/UpdateBulk");
const RatesUpdate = () => import("@/views/Promo/Detail/Rates/update");
const PromoImport = () => import("@/views/Promo/Detail/Rates/import");

const Store = () => import("@/views/Store");
const StoreUpdate = () => import("@/views/Store/update");
const DetailStore = () => import("@/views/Store/Detail");
const MappingSF = () => import("@/views/Store/MappingSF");
const MappingSFImport = () => import("@/views/Store/MappingSF/Import");
const ExclusiveStoreRate = () => import("@/views/Store/ExclusiveStoreRate");
const ExclusiveStoreRateDetail = () =>
  import("@/views/Store/ExclusiveStoreRate/detail");
const ExclusiveStoreRateImport = () =>
  import("@/views/Store/ExclusiveStoreRate/import");
const ExclusiveStoreRateUpdate = () =>
  import("@/views/Store/ExclusiveStoreRate/update");
const StoreMarketingSchemeUpdate = () =>
  import("@/views/Store/Detail/MarketingScheme/update");
const ReportingStore = () => import("@/views/Store/reporting");

const StoreGroups = () => import("@/views/Store/Groups");
const StoreGroupsDetail = () => import("@/views/Store/Groups/detail");

const Membership = () => import("@/views/Membership");
const DetailMembership = () => import("@/views/Membership/Detail/index");
const CreateMembership = () => import("@/views/Membership/create");
const ReportingMembership = () => import("@/views/Membership/reporting");

const MembershipSilo = () => import("@/views/Membership/Silo");
const MembershipSiloDetail = () => import("@/views/Membership/Silo/detail");

const BlacklistPhoneNo = () => import("@/views/Membership/BlacklistPhoneNo");
const BlacklistPhoneNoCreate = () =>
  import("@/views/Membership/BlacklistPhoneNo/create");
const BlacklistPhoneNoDetail = () =>
  import("@/views/Membership/BlacklistPhoneNo/detail");
const BlacklistPhoneNoImport = () =>
  import("@/views/Membership/BlacklistPhoneNo/import");

const ReplaceCardNumber = () => import("@/views/Membership/ReplaceCardNumber");

const Product = () => import("@/views/Product");
const ProductUpdate = () => import("@/views/Product/update");
const DetailProduct = () => import("@/views/Product/detail");

const ProductGroup = () => import("@/views/Product/ProductGroup");
const DetailProductGroup = () => import("@/views/Product/ProductGroup/detail");
const ProductGroupUpdate = () => import("@/views/Product/ProductGroup/update");
const ProductInsurance = () => import("@/views/Product/Insurance");
const ProductInsuranceDetail = () =>
  import("@/views/Product/Insurance/Detail/index");
const ProductInsuranceV2 = () => import("@/views/Product/InsuranceV2");
const ProductInsuranceDetailV2 = () =>
  import("@/views/Product/InsuranceV2/Detail/index");
const MasterInsuranceSpektra = () => import("@/views/Insurance/");
const MasterInsuranceSpektraDetail = () => import("@/views/Insurance/Detail");

const ProductGroupNMC = () =>
  import("@/views/MasterNonSpektra/Product/ProductGroup");
const DetailProductGroupNMC = () =>
  import("@/views/MasterNonSpektra/Product/ProductGroup/detail");
const ProductGroupNMCUpdate = () =>
  import("@/views/MasterNonSpektra/Product/ProductGroup/update");

const CreateRiskProfile = () => import("@/views/Membership/RiskProfile/create");
const DetailRiskProfile = () => import("@/views/Membership/RiskProfile/detail");
const DetailEscrow = () => import("@/views/Membership/Escrow/detail.vue");
const UpdateEscrow = () => import("@/views/Membership/Escrow/update.vue");
const EscrowBalanceTracking = () =>
  import("@/views/Membership/Escrow/balanceTracking.vue");

const CreateMembershipDocument = () =>
  import("@/views/Membership/Document/create");

const ImportMembership = () => import("@/views/ImportMembership");
const DetailImportMembership = () => import("@/views/ImportMembership/detail");
const CreateImportMembership = () => import("@/views/ImportMembership/create");

const ImportMembershipEmployee = () =>
  import("@/views/ImportMembership/Employee");
const DetailImportMembershipEmployee = () =>
  import("@/views/ImportMembership/Employee/detail");
const CreateImportMembershipEmployee = () =>
  import("@/views/ImportMembership/Employee/create");

const MembershipEmployee = () => import("@/views/EmployeeMembership/index");
const DetailMembershipEmployee = () =>
  import("@/views/EmployeeMembership/detail");

const MembershipRiskProfile = () => import("@/views/MembershipRiskProfile");
const MembershipSetupForDatabase = () =>
  import("@/views/MembershipSetupForDatabase/index");
const MembershipCreateSetupForDatabase = () =>
  import("@/views/MembershipSetupForDatabase/Create/index");
const MembershipDetailSetupForDatabase = () =>
  import("@/views/MembershipSetupForDatabase/Detail/index");

const Company = () => import("@/views/Company");
const DetailCompany = () => import("@/views/Company/detail");

const FinancialScheme = () => import("@/views/FinancialScheme");
const DetailFinancialScheme = () => import("@/views/FinancialScheme/Detail");
const CreateFinancialScheme = () =>
  import("@/views/FinancialScheme/Create/mpf");
const CreateFinancialSchemeNMC = () =>
  import("@/views/FinancialScheme/Create/nmc");

const Branch = () => import("@/views/Branch");
const DetailBranch = () => import("@/views/Branch/Detail");
const CreateBranch = () => import("@/views/Branch/create");
const ImportBranch = () => import("@/views/Branch/import");
const ImportBranchBulk = () => import("@/components/Default/importBulk");
const BranchRate = () => import("@/views/Branch/Detail/Rate");
const CreateBranchRate = () => import("@/views/Branch/Detail/Rate/create");
const DetailBranchRate = () => import("@/views/Branch/Detail/Rate/detail");
const CreateBranchExclusiveRate = () =>
  import("@/views/Branch/Detail/ExclusiveRate/create");
const BranchFee = () => import("@/views/Branch/Detail/Fee");
const CreateBranchFee = () => import("@/views/Branch/Detail/Fee/create");
const DetailBranchFee = () => import("@/views/Branch/Detail/Fee/Detail");
const CreateBranchExclusive = () =>
  import("@/views/Branch/Detail/Fee/createExclusive");

const NotificationError = () => import("@/views/Notification");
const NotificationErrorDetail = () => import("@/views/Notification/Detail");
const NotificationErrorCreate = () => import("@/views/Notification/create.vue");

const CardResetReason = () => import("@/views/CardResetReason");
const CardResetReasonDetail = () =>
  import("@/views/CardResetReason/detail.vue");
const CardResetReasonCreate = () =>
  import("@/views/CardResetReason/create.vue");

const OrderLog = () => import("@/views/Order/index");

const ReasonForDeliveryReturn = () =>
  import("@/views/Master/ReasonForReturn/Delivery");
const ReasonForDeliveryReturnDetail = () =>
  import("@/views/Master/ReasonForReturn/Delivery/detail");
const ReasonForDeliveryReturnCreate = () =>
  import("@/views/Master/ReasonForReturn/Delivery/create");

const ReasonForVerificationReturn = () =>
  import("@/views/Master/ReasonForReturn/Verification");
const ReasonForVerificationReturnDetail = () =>
  import("@/views/Master/ReasonForReturn/Verification/detail");
const ReasonForVerificationReturnCreate = () =>
  import("@/views/Master/ReasonForReturn/Verification/create");

const MemberManagement = () => import("@/views/MemberManagement");
const MemberManagementDetail = () => import("@/views/MemberManagement/detail");
const MemberManagementCreate = () => import("@/views/MemberManagement/create");

const ExternalSource = () => import("@/views/Membership/ExternalSource");
const ExternalSourceCreate = () =>
  import("@/views/Membership/ExternalSource/create");
const ExternalSourceDetail = () =>
  import("@/views/Membership/ExternalSource/detail");

const Page404 = () => import("@/views/Page404");
const Page500 = () => import("@/views/Page500");
const Page503 = () => import("@/views/Page503");

const FAQ = () => import("@/views/FAQ");

const AppSettingProperties = () => import("@/views/AppSettingProperties");
const AppSettingPropertiesCreate = () =>
  import("@/views/AppSettingProperties/create");
const AppSettingPropertiesDetail = () =>
  import("@/views/AppSettingProperties/detail");

const AuditTrail = () => import("@/views/AuditTrail");
const AuditTrailDetail = () => import("@/views/AuditTrail/detail");

const TransactionLog = () => import("@/views/TransactionLog");
const TransactionLogDetail = () =>
  import("@/views/TransactionLog/Detail/TransactionLog");
const RejectLogDetail = () => import("@/views/TransactionLog/Detail/RejectLog");
const ErrorLogDetail = () =>
  import("@/views/TransactionLog/Detail/TransactionErrorLog");
const OTPLogDetail = () => import("@/views/TransactionLog/Detail/OTPLog");
const OrderfullLogDetail = () =>
  import("@/views/TransactionLog/Detail/OrderfullLog");
const SchedulerLogDetail = () =>
  import("@/views/TransactionLog/Detail/SchedulerLog");
const BalanceTrackingLogDetail = () =>
  import("@/views/TransactionLog/Detail/BalanceTrackingLog");

const UpdateSMSContent = () => import("@/views/UpdateSMSContent");
const UpdateSMSContentUpdate = () =>
  import("@/views/UpdateSMSContent/update.vue");

// Master Branch UFI
const MasterBranchUFI = () => import("@/views/MasterNonSpektra/Branch");
const MasterDetailBranchUFI = () =>
  import("@/views/MasterNonSpektra/Branch/Detail");
const MasterCreateBranchUFI = () =>
  import("@/views/MasterNonSpektra/Branch/create");
const MasterImportBranchUFI = () =>
  import("@/views/MasterNonSpektra/Branch/import");
const MasterUFIBranchRate = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Rate");
const MasterUFICreateBranchRate = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Rate/create");
const MasterUFIDetailBranchRate = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Rate/detail");
const MasterCreateExclusiveRateBranchUFI = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/ExclusiveRate/create");
const UFIMasterBranchFee = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Fee");
const UFIMasterCreateBranchFee = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Fee/create");
const MasterUFIDetailBranchFee = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Fee/Detail");
const MasterUFICreateBranchExclusive = () =>
  import("@/views/MasterNonSpektra/Branch/Detail/Fee/createExclusive");

// Master Kiosk UFI
const MasterKioskUFI = () => import("@/views/MasterNonSpektra/Kiosk");
const MasterKioskUFIUpdate = () =>
  import("@/views/MasterNonSpektra/Kiosk/update");
const MasterKioskUFIDetail = () =>
  import("@/views/MasterNonSpektra/Kiosk/detail");

// Promo UFI
const PromoUFI = () => import("@/views/MasterNonSpektra/Promo");
const PromoUFIDetail = () => import("@/views/MasterNonSpektra/Promo/Detail");
const PromoUFIImport = () =>
  import("@/views/MasterNonSpektra/Promo/Detail/Rates/import");
const PromoUFIUpdate = () => import("@/views/MasterNonSpektra/Promo/update");
const PromoUFIUpdateBulk = () =>
  import("@/views/MasterNonSpektra/Promo/UpdateBulk");
const PromoUFIUpdateRate = () =>
  import("@/views/MasterNonSpektra/Promo/Detail/Rates/update");

// Object UFI
const ObjectUFI = () => import("@/views/MasterNonSpektra/Object");
const ObjectUFIDetail = () => import("@/views/MasterNonSpektra/Object/detail");
const ObjectUFIUpdate = () => import("@/views/MasterNonSpektra/Object/update");
const ObjectGroupUFI = () =>
  import("@/views/MasterNonSpektra/Object/ObjectGroup");
const ObjectGroupUFIDetail = () =>
  import("@/views/MasterNonSpektra/Object/ObjectGroup/detail");
const ObjectGroupUFIUpdate = () =>
  import("@/views/MasterNonSpektra/Object/ObjectGroup/update");

//Dealer UFI
const MasterDealerUFI = () => import("@/views/MasterNonSpektra/Dealer");
const MasterDealerUFICreate = () =>
  import("@/views/MasterNonSpektra/Dealer/create");
const MasterDealerUFIDetail = () =>
  import("@/views/MasterNonSpektra/Dealer/Detail");

//Dealer UFI
const Region = () => import("@/views/Region");
const RegionDetail = () => import("@/views/Region/detail");

// Master LOB
const MasterLOB = () => import("@/views/MasterLOB");
const MasterLOBCreate = () => import("@/views/MasterLOB/create");
const MasterLOBDetail = () => import("@/views/MasterLOB/detail");

// Membership Group
const MembershipGroup = () => import("@/views/MemberGroup");
const ImportMembershipGroup = () => import("@/views/MemberGroup/import");
const CreateMembershipGroup = () => import("@/views/MemberGroup/Setup/create");
const CreateMembershipGroupMapping = () =>
  import("@/views/MemberGroup/Mapping/create");

const PhotosScreeningMember = () => import("@/views/PhotosScreeningMember");

// Menu Management
const MenuManagement = () => import("@/views/MenuManagement");
const MenuManagementDetail = () => import("@/views/MenuManagement/detail");
const MenuManagementCreate = () => import("@/views/MenuManagement/create");
const SubMenuManagementDetail = () =>
  import("@/views/MenuManagement/SubMenu/detail");
const SubMenuManagementCreate = () =>
  import("@/views/MenuManagement/SubMenu/create");

// Customer Confirmation Management
const CustomerConfirmationManagement = () =>
  import("@/views/CustomerConfirmation");
const CustomerConfirmationManagementCreate = () =>
  import("@/views/CustomerConfirmation/create");
const CustomerConfirmationManagementDetail = () =>
  import("@/views/CustomerConfirmation/Detail/index.vue");
const CustomerConfirmationManagementHistoryDetail = () =>
  import("@/views/CustomerConfirmation/history");

// Download Management
const DownloadManagement = () => import("@/views/DownloadManagement");
const DownloadManagementDetail = () =>
  import("@/views/DownloadManagement/detail");

// Customer Satisfaction Survey
const CustomerSatisfactionSurvey = () =>
  import("@/views/CustomerSatisfactionSurvey/index.vue");
const CustomerSatisfactionSurveyDetail = () =>
  import("@/views/CustomerSatisfactionSurvey/detail.vue");

// Mediator
const Mediator = () => import("@/views/Mediator/Mediator");
const MediatorSAO = () => import("@/views/Mediator/SAO");

// Family Financing
const FamilyFinancing = () => import("@/views/FamilyFinancing");
const FamilyFinancingDetail = () => import("@/views/FamilyFinancing/detail");

// Pre Order Agent
const PreOrderAgent = () => import("@/views/PreOrderAgent");
const PreOrderAgentDetail = () => import("@/views/PreOrderAgent/Detail");

import {
  USER,
  HOME,
  ABOUT,
  PROFILE,
  LOGIN,
  CARD_DISTRIBUTION,
  CARD_VERIFICATION,
  CARD_STOCK,
  CARD_ISSUANCE,
  CARD_LOST,
  CARD_TRACKING,
  CARD_GENERATOR,
  CARD_RESERVATIONS,
  MASTER,
  PROMO,
  STORE,
  MEMBERSHIP,
  QANUN_BRANCH,
  ROLES,
  ERROR_PAGE,
  ECARD_PRINTING,
  PRODUCT,
  PO_STATUS,
  COMPANIES,
  FINANCIAL_SCHEME,
  BRANCH,
  ORDERS,
  NOTIFICATION_ERROR,
  CARD_RESET_REASON,
  PROGRAM_TYPE,
  MEMBER_MANAGEMENT,
  MASTER_BANNER,
  SETTING_PROPERTIES,
  NMC,
  UFI,
  DEBUG,
  TIERING,
  MASTER_TOKEN,
  REGIONS,
  MASTER_LOB,
  MENU_MANAGEMENT,
  CUSTOMER_CONFIRMATION_MANAGEMENT,
  DOWNLOAD_MANAGEMENT,
  CUSTOMER_SURVEY,
  MEDIATOR,
  FAMILY_FINANCING,
  PRE_ORDER_AGENT
} from "./names.type";

export const configRoutes = () => {
  return [
    {
      path: "/",
      component: TheContainer,
      meta: {
        title: "Home"
      },
      children: [
        {
          path: "",
          name: HOME,
          component: Home,
          meta: {
            requiresAuth: true,
            title: "Home"
          }
        },
        {
          path: "/profile",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Profile"
          },
          children: [
            {
              path: "",
              name: PROFILE.ROOT,
              component: Profile,
              meta: {
                requiresAuth: true,
                title: "Detail Profile"
              }
            },
            {
              path: "update",
              name: PROFILE.UPDATE,
              component: UpdateProfile,
              meta: {
                requiresAuth: true,
                title: "Ubah Profile"
              }
            },
            {
              path: "change-password",
              name: PROFILE.CHANGE_PASSWORD,
              component: ChangePasswordProfile,
              meta: {
                requiresAuth: true,
                title: "Ubah Password Profile"
              }
            }
          ]
        },
        {
          path: "/user",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Daftar Pengguna"
          },
          children: [
            {
              path: "",
              name: USER.BROWSE,
              component: UserManagement,
              meta: {
                requiresAuth: true,
                title: "Daftar Pengguna",
                privilege: USER.BROWSE
              }
            },
            {
              path: "create",
              name: USER.REGISTERING_EXTERNAL,
              component: CreateUserManagement,
              meta: {
                requiresAuth: true,
                title: "Tambah Pengguna",
                privilege: USER.REGISTERING_EXTERNAL
              }
            },
            {
              path: "update",
              name: USER.UPDATE,
              component: CreateUserManagement,
              meta: {
                requiresAuth: true,
                title: "Ubah Pengguna",
                privilege: USER.BROWSE
              }
            },
            {
              path: "reporting",
              name: USER.REPORTING,
              component: ReportingUserManagement,
              meta: {
                requiresAuth: true,
                title: "User Reporting",
                privilege: USER.REPORTING
              }
            },
            {
              path: ":userId",
              name: USER.DETAIL,
              component: DetailUserManagement,
              meta: {
                requiresAuth: true,
                title: "Detail Pengguna",
                privilege: USER.BROWSE,
                bcDynamic: true,
                bcType: "detail-user"
              }
            }
          ]
        },
        {
          path: "/card-verification",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Card Verification"
          },
          children: [
            {
              path: "",
              name: CARD_VERIFICATION.ROOT,
              component: CardVerification,
              meta: {
                requiresAuth: true,
                title: "Card Verification List",
                privilege: CARD_VERIFICATION.ROOT
              }
            },
            {
              path: ":cardVerificationId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-card-verification"
              },
              children: [
                {
                  path: "",
                  name: CARD_VERIFICATION.DETAIL.ROOT,
                  component: CardVerificationDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: CARD_VERIFICATION.ROOT
                  }
                },
                {
                  path: "manual-checking",
                  name: CARD_VERIFICATION.DETAIL.MANUAL_CHECK,
                  component: CardVerificationManualCheck,
                  meta: {
                    requiresAuth: true,
                    title: "Manual Checking",
                    privilege: CARD_VERIFICATION.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/card-stock",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Card Stock"
          },
          children: [
            {
              path: "",
              name: CARD_STOCK.ROOT,
              component: CardStock,
              meta: {
                requiresAuth: true,
                title: "Card Stock List",
                privilege: CARD_STOCK.ROOT
              }
            },
            {
              path: "branch-page/:cardStockId",
              name: CARD_STOCK.DETAIL.BRANCH,
              component: CardStockDetail,
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "card-stock-detail",
                privilege: CARD_STOCK.ROOT
              }
            },
            {
              path: "mra-page/:cardStockId",
              name: CARD_STOCK.DETAIL.MRA,
              component: CardStockDetail,
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "card-stock-detail",
                privilege: CARD_STOCK.ROOT
              }
            }
          ]
        },
        {
          path: "/reporting-card-distribution/",
          name: CARD_DISTRIBUTION.REPORTING,
          component: ReportingCardDistribution,
          meta: {
            requiresAuth: true,
            title: "Card Distribution Reporting",
            privilege: CARD_DISTRIBUTION.REPORTING
          }
        },
        {
          path: "/card-assignment",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Card Assignment"
          },
          children: [
            {
              path: "",
              name: CARD_DISTRIBUTION.ASSIGNMENT.LIST,
              component: CardAssignment,
              meta: {
                requiresAuth: true,
                title: "Card Assignments List",
                privilege: CARD_DISTRIBUTION.ASSIGNMENT.LIST
              }
            },
            {
              path: "create",
              name: CARD_DISTRIBUTION.ASSIGNMENT.CREATE,
              component: CardAssignmentCreate,
              meta: {
                requiresAuth: true,
                title: "Create",
                privilege: CARD_DISTRIBUTION.ASSIGNMENT.LIST
              }
            },
            {
              path: "search",
              name: CARD_DISTRIBUTION.ASSIGNMENT.SEARCH.RESULT,
              component: CardAssignmentSearchResult,
              meta: {
                requiresAuth: true,
                title: "Search",
                privilege: CARD_DISTRIBUTION.ASSIGNMENT.LIST
              }
            },
            {
              path: ":assignId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "assign-id"
              },
              children: [
                {
                  path: "",
                  name: CARD_DISTRIBUTION.ASSIGNMENT.DETAIL,
                  component: CardAssignmentDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: CARD_DISTRIBUTION.ASSIGNMENT.LIST
                  }
                },
                {
                  path: "detail-page/:detailAssignId",
                  name: CARD_DISTRIBUTION.ASSIGNMENT.CARD_LIST.DETAIL,
                  component: CardAssignmentCardListDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    bcDynamic: true,
                    bcType: "detail-assign-id",
                    privilege: CARD_DISTRIBUTION.ASSIGNMENT.LIST
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/card-pickup",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Card Pick-Up"
          },
          children: [
            {
              path: "",
              name: CARD_DISTRIBUTION.PICK_UP.LIST,
              component: CardPickUp,
              meta: {
                requiresAuth: true,
                title: "Card Assignments List",
                privilege: CARD_DISTRIBUTION.PICK_UP.LIST
              }
            },
            {
              path: "create",
              name: CARD_DISTRIBUTION.PICK_UP.CREATE,
              component: CardPickUpCreate,
              meta: {
                requiresAuth: true,
                title: "Create",
                privilege: CARD_DISTRIBUTION.PICK_UP.LIST
              }
            },
            {
              path: ":pickUpId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "pickUpid"
              },
              children: [
                {
                  path: "",
                  name: CARD_DISTRIBUTION.PICK_UP.DETAIL,
                  component: CardPickUpDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: CARD_DISTRIBUTION.PICK_UP.LIST
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/card-generator",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Card No Generator Setup"
          },
          children: [
            {
              path: "",
              name: CARD_GENERATOR.SETUP,
              component: CardNoGeneratorSetup,
              meta: {
                requiresAuth: true,
                title: "Card No Generator Setup",
                privilege: CARD_GENERATOR.SETUP
              }
            },
            {
              path: "branch",
              name: CARD_GENERATOR.DELIVER.TO_BRANCH,
              component: CardGeneratorBranch,
              meta: {
                requiresAuth: true,
                title: "Deliver to Branch",
                privilege: CARD_GENERATOR.SETUP
              }
            },
            {
              path: "customer",
              name: CARD_GENERATOR.DELIVER.TO_CUSTOMER,
              component: CardGeneratorCustomer,
              meta: {
                requiresAuth: true,
                title: "Deliver to Customer",
                privilege: CARD_GENERATOR.SETUP
              }
            }
          ]
        },
        {
          path: "/card-reservations",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Card No Reservations"
          },
          children: [
            {
              path: "",
              name: CARD_RESERVATIONS.ROOT,
              component: CardNoReservationsList,
              meta: {
                requiresAuth: true,
                title: "Card No Reservations",
                privilege: CARD_RESERVATIONS.ROOT
              }
            },
            {
              path: "create",
              name: CARD_RESERVATIONS.ADD,
              component: CardNoReservationAdd,
              meta: {
                requiresAuth: true,
                title: "Add",
                privilege: CARD_RESERVATIONS.ROOT
              }
            },
            {
              path: "import",
              name: CARD_RESERVATIONS.IMPORT,
              component: CardNoReservationImport,
              meta: {
                requiresAuth: true,
                title: "Import",
                privilege: CARD_RESERVATIONS.ROOT
              }
            },
            {
              path: ":detailReservId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-reserve"
              },
              children: [
                {
                  path: "",
                  name: CARD_RESERVATIONS.DETAIL,
                  component: CardNoReservationDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: CARD_RESERVATIONS.ROOT
                  }
                },
                {
                  path: "edit-page/:reservId",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    title: "Edit"
                  },
                  children: [
                    {
                      path: "",
                      name: CARD_RESERVATIONS.EDIT,
                      component: CardNoReservationAdd,
                      meta: {
                        requiresAuth: true,
                        title: "Edit",
                        privilege: CARD_RESERVATIONS.ROOT
                      }
                    }
                  ]
                }
              ]
            },
            {
              path: "selection-page/card",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Card Selection"
              },
              children: [
                {
                  path: "",
                  name: CARD_RESERVATIONS.SELECT_ISSUANCE.ROOT,
                  component: CardNoReservationSelection,
                  meta: {
                    requiresAuth: true,
                    title: "Card Selection",
                    privilege: CARD_RESERVATIONS.ROOT
                  }
                },
                {
                  path: ":sequenceId",
                  name: CARD_RESERVATIONS.SELECT_ISSUANCE.BRANCH_SELECTION,
                  component: BranchSelection,
                  meta: {
                    requiresAuth: true,
                    title: "Branch Selection",
                    privilege: CARD_RESERVATIONS.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/card-issuance",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Card Issuance"
          },
          children: [
            {
              path: "",
              name: CARD_ISSUANCE.LIST,
              component: CardIssuance,
              meta: {
                requiresAuth: true,
                title: "Card Issuance List",
                privilege: CARD_ISSUANCE.LIST
              }
            },
            {
              path: ":detailId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Card Issuance Detail",
                bcDynamic: true,
                bcType: "detail-issuance"
              },
              children: [
                {
                  path: "",
                  name: CARD_ISSUANCE.DETAIL.INFO,
                  component: CardIssuanceDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Card Issuance Detail Info",
                    privilege: CARD_ISSUANCE.LIST
                  }
                },
                {
                  path: "card-page/:cardId",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    title: "Card List Detail",
                    bcDynamic: true,
                    bcType: "detail-card-list"
                  },
                  children: [
                    {
                      path: "",
                      name: CARD_ISSUANCE.DETAIL.CARD_LIST.DETAIL,
                      component: CardListDetail,
                      meta: {
                        requiresAuth: true,
                        title: "Card Issuance Detail Card",
                        privilege: CARD_ISSUANCE.LIST
                      }
                    }
                  ]
                },
                {
                  path: "delivery-page/:deliveryId",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    title: "Delivery List Detail",
                    bcDynamic: true,
                    bcType: "detail-delivery-list"
                  },
                  children: [
                    {
                      path: "",
                      name: CARD_ISSUANCE.DETAIL.DELIVERY_LIST.DETAIL,
                      component: DeliveryListDetail,
                      meta: {
                        requiresAuth: true,
                        title: "Delivery List Detail",
                        privilege: CARD_ISSUANCE.LIST
                      }
                    },
                    {
                      path: "card-list",
                      name: CARD_ISSUANCE.DETAIL.DELIVERY_LIST.CARD_LIST,
                      component: DeliveryCardList,
                      meta: {
                        requiresAuth: true,
                        title: "Card List",
                        privilege: CARD_ISSUANCE.LIST
                      }
                    },
                    {
                      path: "upload-receipt",
                      name: CARD_ISSUANCE.DETAIL.DELIVERY_LIST.UPLOAD_RECEIPT,
                      component: UploadReceipt,
                      meta: {
                        requiresAuth: true,
                        title: "Upload Receipt",
                        privilege: CARD_ISSUANCE.LIST
                      }
                    }
                  ]
                },
                {
                  path: "customer-deliver",
                  name: CARD_ISSUANCE.DETAIL.CUSTOMER_DELIVER,
                  component: CustomerDeliver,
                  meta: {
                    requiresAuth: true,
                    title: "Deliver",
                    privilege: CARD_ISSUANCE.LIST
                  }
                },
                {
                  path: "branch-deliver",
                  name: CARD_ISSUANCE.DETAIL.BRANCH_DELIVER,
                  component: BranchDeliver,
                  meta: {
                    requiresAuth: true,
                    title: "Deliver",
                    privilege: CARD_ISSUANCE.LIST
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/program-type",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Program Type"
          },
          children: [
            {
              path: "",
              name: PROGRAM_TYPE.ROOT,
              component: ProgramType,
              meta: {
                requiresAuth: true,
                title: "Program Type Browse",
                privilege: PROGRAM_TYPE.ROOT
              }
            },
            {
              path: "create",
              name: PROGRAM_TYPE.CREATE,
              component: ProgramTypeCreate,
              meta: {
                requiresAuth: true,
                title: "Create Program Type",
                privilege: PROGRAM_TYPE.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Update Program Type",
                bcDynamic: true,
                bcType: "detail-program-type"
              },
              children: [
                {
                  path: "",
                  name: PROGRAM_TYPE.DETAIL,
                  component: ProgramTypeDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Program Type",
                    privilege: PROGRAM_TYPE.ROOT
                  }
                },
                {
                  path: "update",
                  name: PROGRAM_TYPE.UPDATE,
                  component: ProgramTypeCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Program Type",
                    privilege: PROGRAM_TYPE.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/master-token-api",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Master Token API Browse"
          },
          children: [
            {
              path: "",
              name: MASTER_TOKEN.ROOT,
              component: MasterTokenAPI,
              meta: {
                requiresAuth: true,
                title: "Master Token API Browse",
                privilege: MASTER_TOKEN.ROOT
              }
            },
            {
              path: "create",
              name: MASTER_TOKEN.CREATE,
              component: MasterTokenAPICreate,
              meta: {
                requiresAuth: true,
                title: "Create Master Token API",
                privilege: MASTER_TOKEN.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Update API Token",
                bcDynamic: true,
                bcType: "master-token-api"
              },
              children: [
                {
                  path: "",
                  name: MASTER_TOKEN.DETAIL,
                  component: MasterTokenAPIDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Master Token API",
                    privilege: MASTER_TOKEN.ROOT
                  }
                },
                {
                  path: "update",
                  name: MASTER_TOKEN.UPDATE,
                  component: MasterTokenAPICreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Master Token API",
                    privilege: MASTER_TOKEN.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/tiering-plafond",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Master Tiering"
          },
          children: [
            {
              path: "",
              name: TIERING.ROOT,
              component: MasterTiering,
              meta: {
                requiresAuth: true,
                title: "Master Tiering Browse",
                privilege: TIERING.ROOT
              }
            },
            {
              path: "create",
              name: TIERING.CREATE,
              component: MasterTieringCreate,
              meta: {
                requiresAuth: true,
                title: "Create Tiering",
                privilege: TIERING.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Tiering",
                bcDynamic: true,
                bcType: "detail-tiering-plafond"
              },
              children: [
                {
                  path: "",
                  name: TIERING.DETAIL,
                  component: MasterTieringDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Tiering",
                    privilege: TIERING.ROOT
                  }
                },
                {
                  path: "update",
                  name: TIERING.UPDATE,
                  component: MasterTieringCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Tiering",
                    privilege: TIERING.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/faq",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "FAQ Editor"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.FAQ.ROOT,
              component: FAQ,
              meta: {
                requiresAuth: true,
                title: "FAQ Editor",
                privilege: MEMBERSHIP.FAQ.ROOT
              }
            }
          ]
        },
        {
          path: "/photos-screening-membership",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Photos Screening Member"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.PHOTOS_SCREENING.ROOT,
              component: PhotosScreeningMember,
              meta: {
                requiresAuth: true,
                title: "Photos Screening Member",
                privilege: MEMBERSHIP.PHOTOS_SCREENING.ROOT
              }
            }
          ]
        },
        {
          path: "/member-management",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Member Management"
          },
          children: [
            {
              path: "",
              name: MEMBER_MANAGEMENT.ROOT,
              component: MemberManagement,
              meta: {
                requiresAuth: true,
                title: "Member Management",
                privilege: MEMBER_MANAGEMENT.ROOT
              }
            },
            {
              path: "create",
              name: MEMBER_MANAGEMENT.CREATE,
              component: MemberManagementCreate,
              meta: {
                requiresAuth: true,
                title: "Create Member Management",
                privilege: MEMBER_MANAGEMENT.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Member Management",
                bcDynamic: true,
                bcType: "detail-member-management"
              },
              children: [
                {
                  path: "",
                  name: MEMBER_MANAGEMENT.DETAIL.ROOT,
                  component: MemberManagementDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Member Management",
                    privilege: MEMBER_MANAGEMENT.ROOT
                  }
                },
                {
                  path: "update",
                  name: MEMBER_MANAGEMENT.UPDATE,
                  component: MemberManagementCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update",
                    privilege: MEMBER_MANAGEMENT.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/download-management",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Download Management"
          },
          children: [
            {
              path: "",
              name: DOWNLOAD_MANAGEMENT.ROOT,
              component: DownloadManagement,
              meta: {
                requiresAuth: true,
                title: "Download Management Browse",
                privilege: DOWNLOAD_MANAGEMENT.ROOT
              }
            },
            {
              path: ":downloadId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Download Management",
                bcDynamic: true,
                bcType: "detail-download-management"
              },
              children: [
                {
                  path: "",
                  name: DOWNLOAD_MANAGEMENT.DETAIL,
                  component: DownloadManagementDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Download Management",
                    privilege: DOWNLOAD_MANAGEMENT.ROOT,
                    bcDynamic: true,
                    bcType: "detail-download-management"
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/menu-management",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Menu Management"
          },
          children: [
            {
              path: "",
              name: MENU_MANAGEMENT.ROOT,
              component: MenuManagement,
              meta: {
                requiresAuth: true,
                title: "Menu Management",
                privilege: MEMBER_MANAGEMENT.ROOT
              }
            },
            {
              path: "create",
              name: MENU_MANAGEMENT.CREATE,
              component: MenuManagementCreate,
              meta: {
                requiresAuth: true,
                title: "Create Menu",
                privilege: MEMBER_MANAGEMENT.ROOT
              }
            },
            {
              path: ":menuId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Menu Management",
                bcDynamic: true,
                bcType: "detail-menu-management"
              },
              children: [
                {
                  path: "",
                  name: MENU_MANAGEMENT.DETAIL.ROOT,
                  component: MenuManagementDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Menu",
                    privilege: MEMBER_MANAGEMENT.ROOT,
                    bcDynamic: true,
                    bcType: "detail-menu-management"
                  }
                },
                {
                  path: "update-page",
                  name: MENU_MANAGEMENT.UPDATE,
                  component: MenuManagementCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Menu",
                    privilege: MEMBER_MANAGEMENT.ROOT,
                    bcDynamic: true,
                    bcType: "detail-menu-management"
                  }
                },
                {
                  path: "submenu-detail-page/:subMenuId",
                  name: MENU_MANAGEMENT.SUB_MENU.DETAIL,
                  component: SubMenuManagementDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Sub Menu",
                    privilege: MEMBER_MANAGEMENT.ROOT,
                    bcDynamic: true,
                    bcType: "detail-sub-menu-management"
                  }
                },
                {
                  path: "create-submenu/",
                  name: MENU_MANAGEMENT.SUB_MENU.CREATE,
                  component: SubMenuManagementCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Create Sub Menu",
                    privilege: MEMBER_MANAGEMENT.ROOT
                  }
                },
                {
                  path: "submenu-update-page/:subMenuId",
                  name: MENU_MANAGEMENT.SUB_MENU.UPDATE,
                  component: SubMenuManagementCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Sub Menu",
                    privilege: MEMBER_MANAGEMENT.ROOT,
                    bcDynamic: true,
                    bcType: "update-sub-menu-management"
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/customer-confirmation",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Customer Confirmation"
          },
          children: [
            {
              path: "",
              name: CUSTOMER_CONFIRMATION_MANAGEMENT.BROWSE,
              component: CustomerConfirmationManagement,
              meta: {
                requiresAuth: true,
                title: "Customer Confirmation",
                privilege: CUSTOMER_CONFIRMATION_MANAGEMENT.BROWSE
              }
            },
            {
              path: "create",
              name: CUSTOMER_CONFIRMATION_MANAGEMENT.CREATE,
              component: CustomerConfirmationManagementCreate,
              meta: {
                requiresAuth: true,
                title: "Create Customer Confirmation",
                privilege: CUSTOMER_CONFIRMATION_MANAGEMENT.BROWSE
              }
            },
            {
              path: ":ccmId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Customer Confirmation",
                bcDynamic: true,
                bcType: "detail-customer-confirmation"
              },
              children: [
                {
                  path: "",
                  name: CUSTOMER_CONFIRMATION_MANAGEMENT.DETAIL,
                  component: CustomerConfirmationManagementDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Customer Confirmation",
                    privilege: CUSTOMER_CONFIRMATION_MANAGEMENT.BROWSE
                  }
                },
                {
                  path: "update",
                  name: CUSTOMER_CONFIRMATION_MANAGEMENT.UPDATE,
                  component: CustomerConfirmationManagementCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Customer Confirmation",
                    privilege: CUSTOMER_CONFIRMATION_MANAGEMENT.BROWSE
                  }
                },
                {
                  path: "history-page/:historyId",
                  name: CUSTOMER_CONFIRMATION_MANAGEMENT.DETAIL_HISTORY,
                  component: CustomerConfirmationManagementHistoryDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail History Customer Confirmation",
                    privilege: CUSTOMER_CONFIRMATION_MANAGEMENT.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/po-status",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "PO Status"
          },
          children: [
            {
              path: "",
              name: PO_STATUS.BROWSE,
              component: POStatus,
              meta: {
                requiresAuth: true,
                title: "PO Status Browse",
                privilege: PO_STATUS.BROWSE
              }
            },
            {
              path: ":poId",
              name: PO_STATUS.DETAIL,
              component: POStatusDetail,
              meta: {
                requiresAuth: true,
                title: "PO Status Detail",
                privilege: PO_STATUS.BROWSE,
                bcDynamic: true,
                bcType: "po-Id"
              }
            }
          ]
        },
        {
          path: "/photos-screening",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Photos Screening"
          },
          children: [
            {
              path: "",
              name: PO_STATUS.PHOTOS_POOLING,
              component: PhotosPoolingSpektra,
              meta: {
                requiresAuth: true,
                title: "Photos Screening",
                privilege: PO_STATUS.PHOTOS_POOLING
              }
            }
          ]
        },
        {
          path: "/po-status-archive",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "PO Status Archive"
          },
          children: [
            {
              path: "",
              name: PO_STATUS.ARCHIVE.BROWSE,
              component: POStatusArchive,
              meta: {
                requiresAuth: true,
                title: "PO Status Archive Browse",
                privilege: PO_STATUS.ARCHIVE.BROWSE
              }
            },
            {
              path: ":poId",
              name: PO_STATUS.ARCHIVE.DETAIL,
              component: POStatusArchiveDetail,
              meta: {
                requiresAuth: true,
                title: "PO Status Archive Detail",
                privilege: PO_STATUS.ARCHIVE.BROWSE,
                bcDynamic: true,
                bcType: "po-Id"
              }
            }
          ]
        },
        {
          path: "/po-status-sales",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "PO Status Sales"
          },
          children: [
            {
              path: "",
              name: PO_STATUS.SALES,
              component: POStatus,
              meta: {
                requiresAuth: true,
                title: "PO Status for Sales",
                privilege: PO_STATUS.SALES
              }
            },
            {
              path: ":poId",
              name: PO_STATUS.DETAIL_SALES,
              component: POStatusDetail,
              meta: {
                requiresAuth: true,
                title: "PO Sales Status Detail",
                privilege: PO_STATUS.SALES,
                bcDynamic: true,
                bcType: "po-Id"
              }
            }
          ]
        },
        {
          path: "/po-status-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "PO Status NMC"
          },
          children: [
            {
              path: "",
              name: NMC.PO_STATUS.BROWSE,
              component: POStatusNMC,
              meta: {
                requiresAuth: true,
                title: "PO Status NMC Browse",
                privilege: NMC.PO_STATUS.BROWSE
              }
            },
            {
              path: ":poId",
              name: NMC.PO_STATUS.DETAIL,
              component: POStatusNMCDetail,
              meta: {
                requiresAuth: true,
                title: "PO Status NMC Detail",
                privilege: NMC.PO_STATUS.BROWSE,
                bcDynamic: true,
                bcType: "po-Id"
              }
            }
          ]
        },
        {
          path: "/po-status-nmc-archive",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "PO Status NMC Archive"
          },
          children: [
            {
              path: "",
              name: NMC.PO_STATUS.ARCHIVE.BROWSE,
              component: POStatusNMCArchive,
              meta: {
                requiresAuth: true,
                title: "PO Status NMC Archive Browse",
                privilege: NMC.PO_STATUS.ARCHIVE.BROWSE
              }
            },
            {
              path: ":poId",
              name: NMC.PO_STATUS.ARCHIVE.DETAIL,
              component: POStatusNMCArchiveDetail,
              meta: {
                requiresAuth: true,
                title: "PO Status NMC Archive Detail",
                privilege: NMC.PO_STATUS.ARCHIVE.BROWSE,
                bcDynamic: true,
                bcType: "po-Id"
              }
            }
          ]
        },
        {
          path: "/photos-screening-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Photos Screening"
          },
          children: [
            {
              path: "",
              name: NMC.PO_STATUS.PHOTOS_SCREENING,
              component: PhotosScreeningNmc,
              meta: {
                requiresAuth: true,
                title: "Photos Screening",
                privilege: NMC.PO_STATUS.PHOTOS_SCREENING
              }
            }
          ]
        },
        {
          path: "/po-status-nmc-sales",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "PO Status NMC Sales"
          },
          children: [
            {
              path: "",
              name: NMC.PO_STATUS.SALES,
              component: POStatusNMC,
              meta: {
                requiresAuth: true,
                title: "PO Status NMC for Sales",
                privilege: NMC.PO_STATUS.SALES
              }
            },
            {
              path: ":poId",
              name: NMC.PO_STATUS.DETAIL_SALES,
              component: POStatusNMCDetail,
              meta: {
                requiresAuth: true,
                title: "PO Sales NMC Status Detail",
                privilege: NMC.PO_STATUS.SALES,
                bcDynamic: true,
                bcType: "po-Id"
              }
            }
          ]
        },
        {
          path: "/ecard-printing",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "e-Card Printing"
          },
          children: [
            {
              path: "",
              name: ECARD_PRINTING.LIST,
              component: eCardPrinting,
              meta: {
                requiresAuth: true,
                title: "e-Card Printing",
                privilege: ECARD_PRINTING.LIST
              }
            },
            {
              path: "select-for-printing",
              name: ECARD_PRINTING.REQUEST_TO_PRINTING.ROOT,
              component: eCardSelectForPrinting,
              meta: {
                requiresAuth: true,
                title: "e-Card Printing",
                privilege: ECARD_PRINTING.LIST
              }
            },
            {
              path: "deliver-to-customer",
              name: ECARD_PRINTING.REQUEST_TO_PRINTING.DELIVER_TO_CUSTOMER,
              component: eCardDeliverCustomer,
              meta: {
                requiresAuth: true,
                title: "Deliver to Customer",
                privilege: ECARD_PRINTING.LIST
              }
            }
          ]
        },
        {
          path: "/card-lost",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Lost Card"
          },
          children: [
            {
              path: "",
              name: CARD_LOST.LIST,
              component: CardLost,
              meta: {
                requiresAuth: true,
                title: "Lost Card List",
                privilege: CARD_LOST.LIST
              }
            },
            {
              path: "create",
              name: CARD_LOST.CREATE,
              component: CardLostCreate,
              meta: {
                requiresAuth: true,
                title: "Create",
                privilege: CARD_LOST.LIST
              }
            },
            {
              path: "reporting",
              name: CARD_LOST.REPORTING,
              component: ReportingCardLost,
              meta: {
                requiresAuth: true,
                title: "Card Lost Reporting",
                privilege: CARD_LOST.LIST
              }
            },
            {
              path: ":lostId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "lostId"
              },
              children: [
                {
                  path: "",
                  name: CARD_LOST.DETAIL,
                  component: CardLostDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: CARD_LOST.LIST
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/card-tracking",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Card Tracking"
          },
          children: [
            {
              path: "",
              name: CARD_TRACKING.BROWSE,
              component: CardTracking,
              meta: {
                requiresAuth: true,
                title: "Card Tracking",
                privilege: CARD_TRACKING.BROWSE
              }
            }
          ]
        },
        {
          path: "/cards",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Cards"
          },
          children: [
            {
              path: "",
              name: CARD_TRACKING.LIST,
              component: CardTrackingList,
              meta: {
                requiresAuth: true,
                title: "Cards",
                privilege: CARD_TRACKING.BROWSE
              }
            },
            {
              path: ":issuanceId",
              name: CARD_TRACKING.DETAIL,
              component: CardTrackingDetail,
              meta: {
                requiresAuth: true,
                title: "Card Tracking Detail",
                privilege: CARD_TRACKING.BROWSE,
                bcDynamic: true,
                bcType: "detail-card-tracking"
              }
            }
          ]
        },
        {
          path: "/master",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Master"
          },
          children: [
            {
              path: "",
              name: MASTER.ROOT,
              component: Master,
              meta: {
                requiresAuth: true,
                title: "master List",
                privilege: MASTER.ROOT
              }
            },
            {
              path: "reporting",
              name: MASTER.REPORTING,
              component: ReportingMaster,
              meta: {
                requiresAuth: true,
                title: "Master Reporting",
                privilege: MASTER.REPORTING
              }
            }
          ]
        },
        {
          path: "/master-banner",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Master Banner"
          },
          children: [
            {
              path: "",
              name: MASTER_BANNER.ROOT,
              component: MasterBanner,
              meta: {
                requiresAuth: true,
                title: "Master Banner List",
                privilege: MASTER_BANNER.ROOT
              }
            },
            {
              path: "create",
              name: MASTER_BANNER.CREATE,
              component: MasterBannerCreate,
              meta: {
                requiresAuth: true,
                title: "Create",
                privilege: MASTER_BANNER.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Update Master Banner",
                bcDynamic: true,
                bcType: "detail-master-banner"
              },
              children: [
                {
                  path: "",
                  name: MASTER_BANNER.DETAIL,
                  component: MasterBannerDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Master Banner",
                    privilege: MASTER_BANNER.ROOT
                  }
                },
                {
                  path: "update",
                  name: MASTER_BANNER.UPDATE,
                  component: MasterBannerCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Master Banner",
                    privilege: MASTER_BANNER.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/master-reason-update",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Reason Update"
          },
          children: [
            {
              path: "",
              name: MASTER.REASON.ROOT,
              component: MasterReasonUpdate,
              meta: {
                requiresAuth: true,
                title: "Reason Update Browse",
                privilege: MASTER.REASON.ROOT
              }
            },
            {
              path: "create",
              name: MASTER.REASON.CREATE,
              component: MasterReasonUpdateCreate,
              meta: {
                requiresAuth: true,
                title: "Create Reason Update",
                privilege: MASTER.REASON.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Update Reason",
                bcDynamic: true,
                bcType: "detail-reason"
              },
              children: [
                {
                  path: "",
                  name: MASTER.REASON.DETAIL,
                  component: MasterReasonUpdateDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Reason",
                    privilege: MASTER.REASON.ROOT
                  }
                },
                {
                  path: "update",
                  name: MASTER.REASON.UPDATE,
                  component: MasterReasonUpdateCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Reason",
                    privilege: MASTER.REASON.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/reasons-for-extension",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Reasons For Extension"
          },
          children: [
            {
              path: "",
              name: MASTER.REASON_FOR_EXTENSION.BROWSE,
              component: MasterReasonForExtension,
              meta: {
                requiresAuth: true,
                title: "Reason For Extension Browse",
                privilege: MASTER.REASON_FOR_EXTENSION.BROWSE
              }
            },
            {
              path: "create",
              name: MASTER.REASON_FOR_EXTENSION.CREATE,
              component: MasterReasonForExtensionCreate,
              meta: {
                requiresAuth: true,
                title: "Create Reason For Extension",
                privilege: MASTER.REASON_FOR_EXTENSION.BROWSE
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Update Reason",
                bcDynamic: true,
                bcType: "detail-reason-extension"
              },
              children: [
                {
                  path: "update",
                  name: MASTER.REASON_FOR_EXTENSION.UPDATE,
                  component: MasterReasonForExtensionCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Reason For Extension",
                    privilege: MASTER.REASON_FOR_EXTENSION.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "branch-cms",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Daftar Branch"
          },
          children: [
            {
              path: "",
              name: MASTER.BRANCH.ROOT,
              component: MasterBranch,
              meta: {
                requiresAuth: true,
                title: "Daftar Branch",
                privilege: MASTER.BRANCH.ROOT
              }
            },
            {
              path: ":branchId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Branch Detail",
                bcDynamic: true,
                bcType: "detail-branch"
              },
              children: [
                {
                  path: "",
                  name: MASTER.BRANCH.DETAIL.ROOT,
                  component: MasterBranchDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Branch Detail",
                    privilege: MASTER.BRANCH.ROOT
                  }
                },
                {
                  path: "update",
                  name: MASTER.BRANCH.DETAIL.UPDATE,
                  component: MasterBranchCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Branch Update",
                    privilege: MASTER.BRANCH.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/card-sources",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Card Sources"
          },
          children: [
            {
              path: "",
              name: MASTER.CARD_SOURCES.ROOT,
              component: CardSources,
              meta: {
                requiresAuth: true,
                title: "Card Sources",
                privilege: MASTER.CARD_SOURCES.ROOT
              }
            },
            {
              path: "create",
              name: MASTER.CARD_SOURCES.CREATE,
              component: CardSourcesCreate,
              meta: {
                requiresAuth: true,
                title: "Create Card Sources",
                privilege: MASTER.CARD_SOURCES.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Card Sources",
                bcDynamic: true,
                bcType: "detail-card-sources-or-types"
              },
              children: [
                {
                  path: "",
                  name: MASTER.CARD_SOURCES.DETAIL,
                  component: CardSourcesDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Card Sources",
                    privilege: MASTER.CARD_SOURCES.ROOT
                  }
                },
                {
                  path: "update",
                  name: MASTER.CARD_SOURCES.UPDATE,
                  component: CardSourcesCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Card Sources",
                    privilege: MASTER.CARD_SOURCES.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/card-types",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Card Types"
          },
          children: [
            {
              path: "",
              name: MASTER.CARD_TYPES.ROOT,
              component: CardSources,
              meta: {
                requiresAuth: true,
                title: "Card Types",
                privilege: MASTER.CARD_TYPES.ROOT
              }
            },
            {
              path: "create",
              name: MASTER.CARD_TYPES.CREATE,
              component: CardSourcesCreate,
              meta: {
                requiresAuth: true,
                title: "Create Card Types",
                privilege: MASTER.CARD_TYPES.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Update Card Types",
                bcDynamic: true,
                bcType: "detail-card-sources-or-types"
              },
              children: [
                {
                  path: "",
                  name: MASTER.CARD_TYPES.DETAIL,
                  component: CardSourcesDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Card Types",
                    privilege: MASTER.CARD_TYPES.ROOT
                  }
                },
                {
                  path: "update",
                  name: MASTER.CARD_TYPES.UPDATE,
                  component: CardSourcesCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Card Types",
                    privilege: MASTER.CARD_TYPES.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/reason-for-loss",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Reason for Loss"
          },
          children: [
            {
              path: "",
              name: MASTER.REASON_FOR_LOSS.ROOT,
              component: MasterReasonForLoss,
              meta: {
                requiresAuth: true,
                title: "Reason for Loss Browse",
                privilege: MASTER.REASON_FOR_LOSS.ROOT
              }
            },
            {
              path: "create",
              name: MASTER.REASON_FOR_LOSS.CREATE,
              component: MasterReasonForLossCreate,
              meta: {
                requiresAuth: true,
                title: "Create Reason for Loss",
                privilege: MASTER.REASON_FOR_LOSS.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Reason for Loss",
                bcDynamic: true,
                bcType: "detail-reason-for-loss"
              },
              children: [
                {
                  path: "",
                  name: MASTER.REASON_FOR_LOSS.DETAIL,
                  component: MasterReasonForLossDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Reason for Loss",
                    privilege: MASTER.REASON_FOR_LOSS.ROOT
                  }
                },
                {
                  path: "update",
                  name: MASTER.REASON_FOR_LOSS.UPDATE,
                  component: MasterReasonForLossCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Reason for Loss",
                    privilege: MASTER.REASON_FOR_LOSS.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/zip-code",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Zip Code"
          },
          children: [
            {
              path: "",
              name: MASTER.ZIPCODE.ROOT,
              component: MasterZipCode,
              meta: {
                requiresAuth: true,
                title: "Zip Code",
                privilege: MASTER.ZIPCODE.ROOT
              }
            },
            {
              path: "create",
              name: MASTER.ZIPCODE.CREATE,
              component: MasterZipCodeCreate,
              meta: {
                requiresAuth: true,
                title: "Zip Code Create",
                privilege: MASTER.ZIPCODE.ROOT
              }
            },
            {
              path: "import",
              name: MASTER.ZIPCODE.IMPORT,
              component: MasterZipCodeImport,
              meta: {
                requiresAuth: true,
                title: "Zip Code Import",
                privilege: MASTER.ZIPCODE.ROOT
              }
            },
            {
              path: ":zipCodeId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Zip Code Detail",
                bcDynamic: true,
                bcType: "detail-zipcode"
              },
              children: [
                {
                  path: "",
                  name: MASTER.ZIPCODE.DETAIL.ROOT,
                  component: MasterZipCodeDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Zip Code Detail",
                    privilege: MASTER.ZIPCODE.ROOT
                  }
                },
                {
                  path: "update",
                  name: MASTER.ZIPCODE.DETAIL.UPDATE,
                  component: MasterZipCodeCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Zip Code Update",
                    privilege: MASTER.ZIPCODE.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/mra",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "MRA"
          },
          children: [
            {
              path: "",
              name: MASTER.MRA.ROOT,
              component: MasterMRA,
              meta: {
                requiresAuth: true,
                title: "MRA",
                privilege: MASTER.MRA.ROOT
              }
            },
            {
              path: "create",
              name: MASTER.MRA.CREATE,
              component: MasterMRACreate,
              meta: {
                requiresAuth: true,
                title: "MRA Create",
                privilege: MASTER.MRA.ROOT
              }
            },
            {
              path: ":mraId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "MRA Detail",
                bcDynamic: true,
                bcType: "detail-mra"
              },
              children: [
                {
                  path: "",
                  name: MASTER.MRA.DETAIL.ROOT,
                  component: MasterMRADetail,
                  meta: {
                    requiresAuth: true,
                    title: "MRA Detail",
                    privilege: MASTER.MRA.ROOT
                  }
                },
                {
                  path: "update",
                  name: MASTER.MRA.DETAIL.UPDATE,
                  component: MasterMRACreate,
                  meta: {
                    requiresAuth: true,
                    title: "MRA Update",
                    privilege: MASTER.MRA.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/mro",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "MRO"
          },
          children: [
            {
              path: "",
              name: MASTER.MRO.ROOT,
              component: MasterMRO,
              meta: {
                requiresAuth: true,
                title: "MRO",
                privilege: MASTER.MRO.ROOT
              }
            },
            {
              path: ":mroId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "MRO Detail",
                bcDynamic: true,
                bcType: "detail-mro"
              },
              children: [
                {
                  path: "",
                  name: MASTER.MRO.DETAIL.ROOT,
                  component: MasterMRODetail,
                  meta: {
                    requiresAuth: true,
                    title: "MRO Detail",
                    privilege: MASTER.MRO.ROOT
                  }
                },
                {
                  path: "update",
                  name: MASTER.MRO.DETAIL.UPDATE,
                  component: MasterMROCreate,
                  meta: {
                    requiresAuth: true,
                    title: "MRO Update",
                    privilege: MASTER.MRO.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/new-promo",
          name: PROMO.NEW_PROMO,
          component: Promo,
          meta: {
            requiresAuth: true,
            title: "Promo List",
            privilege: PROMO.BROWSE,
            flag: {
              name: "New",
              secureId: "new"
            }
          }
        },
        {
          path: "/promo",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Promo"
          },
          children: [
            {
              path: "",
              name: PROMO.BROWSE,
              component: Promo,
              meta: {
                requiresAuth: true,
                title: "Promo List",
                privilege: PROMO.BROWSE
              }
            },
            {
              path: "reporting",
              name: PROMO.REPORTING,
              component: ReportingPromo,
              meta: {
                requiresAuth: true,
                title: "Promo Reporting",
                privilege: PROMO.BROWSE
              }
            },
            {
              path: "update-bulk",
              name: PROMO.UPDATE_BULK,
              component: UpdateBulkPromo,
              meta: {
                requiresAuth: true,
                title: "Update Bulk Promo",
                privilege: PROMO.BROWSE
              }
            },
            {
              path: ":promoId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Promo Detail",
                bcDynamic: true,
                bcType: "detail-promo"
              },
              children: [
                {
                  path: "",
                  name: PROMO.DETAIL,
                  component: PromoDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Promo Detail",
                    privilege: PROMO.BROWSE
                  }
                },
                {
                  path: "update",
                  name: PROMO.UPDATE,
                  component: PromoUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Promo Update",
                    privilege: PROMO.BROWSE
                  }
                },
                {
                  path: "import",
                  name: PROMO.IMPORT,
                  component: PromoImport,
                  meta: {
                    requiresAuth: true,
                    title: "Import Promo Rates",
                    privilege: PROMO.BROWSE
                  }
                },
                {
                  path: "update-page/:updateRatesId",
                  name: PROMO.UPDATE_RATES,
                  component: RatesUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Edit Rates",
                    privilege: PROMO.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/product",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Product"
          },
          children: [
            {
              path: "",
              name: PRODUCT.BROWSE,
              component: Product,
              meta: {
                requiresAuth: true,
                title: "Product List",
                privilege: PRODUCT.BROWSE
              }
            },
            {
              path: ":productId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Product Detail",
                bcDynamic: true,
                bcType: "detail-product"
              },
              children: [
                {
                  path: "",
                  name: PRODUCT.DETAIL,
                  component: DetailProduct,
                  meta: {
                    requiresAuth: true,
                    title: "Product Detail",
                    privilege: PRODUCT.BROWSE
                  }
                },
                {
                  path: "update",
                  name: PRODUCT.UPDATE,
                  component: ProductUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Update",
                    privilege: PRODUCT.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/product-group",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Product Group"
          },
          children: [
            {
              path: "",
              name: PRODUCT.GROUP.BROWSE,
              component: ProductGroup,
              meta: {
                requiresAuth: true,
                title: "Product Group List",
                privilege: PRODUCT.GROUP.BROWSE
              }
            },
            {
              path: "update-page/:productGroupId",
              name: PRODUCT.GROUP.EDIT,
              component: ProductGroupUpdate,
              meta: {
                requiresAuth: true,
                title: "Product Group Update",
                privilege: PRODUCT.GROUP.BROWSE,
                bcDynamic: true,
                bcType: "product-group-id"
              }
            },
            {
              path: ":productGroupId",
              name: PRODUCT.GROUP.DETAIL,
              component: DetailProductGroup,
              meta: {
                requiresAuth: true,
                title: "Product Group Detail",
                privilege: PRODUCT.GROUP.BROWSE,
                bcDynamic: true,
                bcType: "product-group-id"
              }
            }
          ]
        },
        {
          path: "/product-insurance",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Product Insurance"
          },
          children: [
            {
              path: "",
              name: PRODUCT.INSURANCE.BROWSE,
              component: ProductInsurance,
              meta: {
                requiresAuth: true,
                title: "Product Insurance List",
                privilege: PRODUCT.INSURANCE.V2.BROWSE
              }
            },
            {
              path: ":productInsuranceID",
              name: PRODUCT.INSURANCE.DETAIL,
              component: ProductInsuranceDetail,
              meta: {
                requiresAuth: true,
                title: "Product Insurance Detail",
                privilege: PRODUCT.INSURANCE.V2.BROWSE,
                bcDynamic: true,
                bcType: "product-insurance-id"
              }
            }
          ]
        },
        {
          path: "/product-insurance-v2",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Product Insurance"
          },
          children: [
            {
              path: "",
              name: PRODUCT.INSURANCE.V2.BROWSE,
              component: ProductInsuranceV2,
              meta: {
                requiresAuth: true,
                title: "Product Insurance List",
                privilege: PRODUCT.INSURANCE.V2.BROWSE
              }
            },
            {
              path: ":id",
              name: PRODUCT.INSURANCE.V2.DETAIL,
              component: ProductInsuranceDetailV2,
              meta: {
                requiresAuth: true,
                title: "Product Insurance Detail",
                privilege: PRODUCT.INSURANCE.V2.BROWSE,
                bcDynamic: true,
                bcType: "product-insurance-id"
              }
            }
          ]
        },
        {
          path: "/master-insurance",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Insurance Spektra"
          },
          children: [
            {
              path: "",
              name: MASTER.INSURANCE.BROWSE,
              component: MasterInsuranceSpektra,
              meta: {
                requiresAuth: true,
                title: "Insurance Spektra",
                privilege: MASTER.INSURANCE.BROWSE
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Insurance Spektra",
                bcDynamic: true,
                bcType: "detail-master-product-insurance-mpf"
              },
              children: [
                {
                  path: "",
                  name: MASTER.INSURANCE.DETAIL,
                  component: MasterInsuranceSpektraDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Insurance Spektra",
                    privilege: MASTER.INSURANCE.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/pre-order-agent",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Pre Order Agent"
          },
          children: [
            {
              path: "",
              name: PRE_ORDER_AGENT.BROWSE,
              component: PreOrderAgent,
              meta: {
                requiresAuth: true,
                title: "Pre Order Agent",
                privilege: PRE_ORDER_AGENT.BROWSE
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Pre Order Agent",
                bcDynamic: true,
                bcType: "detail-pre-order-agent"
              },
              children: [
                {
                  path: "",
                  name: PRE_ORDER_AGENT.DETAIL,
                  component: PreOrderAgentDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Pre Order Agent",
                    privilege: PRE_ORDER_AGENT.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/new-store",
          name: STORE.NEW_STORE,
          component: Store,
          meta: {
            requiresAuth: true,
            title: "Stores",
            privilege: STORE.BROWSE,
            flag: {
              name: "NEW",
              secureId: "NEW"
            }
          }
        },
        {
          path: "/store",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Store"
          },
          children: [
            {
              path: "",
              name: STORE.BROWSE,
              component: Store,
              meta: {
                requiresAuth: true,
                title: "Stores",
                privilege: STORE.BROWSE
              }
            },
            {
              path: "mapping-sf",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Mapping SF"
              },
              children: [
                {
                  path: "",
                  name: STORE.MAPPING_SF.BROWSE,
                  component: MappingSF,
                  meta: {
                    requiresAuth: true,
                    title: "Mapping SF",
                    privilege: STORE.BROWSE
                  }
                },
                {
                  path: "import",
                  name: STORE.MAPPING_SF.IMPORT,
                  component: MappingSFImport,
                  meta: {
                    requiresAuth: true,
                    title: "Import",
                    privilege: STORE.MAPPING_SF.BROWSE
                  }
                }
              ]
            },
            {
              path: "exclusive-rate",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Exclusive Store Rate"
              },
              children: [
                {
                  path: "",
                  name: STORE.EXCLUSIVE_RATE.BROWSE,
                  component: ExclusiveStoreRate,
                  meta: {
                    requiresAuth: true,
                    title: "Exclusive Store Rate",
                    privilege: STORE.EXCLUSIVE_RATE.BROWSE
                  }
                },
                {
                  path: "import",
                  name: STORE.EXCLUSIVE_RATE.IMPORT,
                  component: ExclusiveStoreRateImport,
                  meta: {
                    requiresAuth: true,
                    title: "Import",
                    privilege: STORE.EXCLUSIVE_RATE.BROWSE
                  }
                },
                {
                  path: ":storeId",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    title: "Exclusive Store Rate Detail",
                    bcDynamic: true,
                    bcType: "detail-exclusive-store"
                  },
                  children: [
                    {
                      path: "",
                      name: STORE.EXCLUSIVE_RATE.DETAIL,
                      component: ExclusiveStoreRateDetail,
                      meta: {
                        requiresAuth: true,
                        title: "SExclusive Store Rate Detai",
                        privilege: STORE.EXCLUSIVE_RATE.BROWSE
                      }
                    },
                    {
                      path: "update",
                      name: STORE.EXCLUSIVE_RATE.UPDATE,
                      component: ExclusiveStoreRateUpdate,
                      meta: {
                        requiresAuth: true,
                        title: "Update",
                        privilege: STORE.EXCLUSIVE_RATE.BROWSE
                      }
                    }
                  ]
                }
              ]
            },
            {
              path: "reporting",
              // Edit Soon
              name: STORE.REPORTING + "12312123",
              component: ReportingStore,
              meta: {
                requiresAuth: true,
                title: "Store Reporting",
                privilege: STORE.REPORTING
              }
            },
            {
              path: ":storeId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Store Detail",
                bcDynamic: true,
                bcType: "detail-store"
              },
              children: [
                {
                  path: "",
                  name: STORE.DETAIL.ROOT,
                  component: DetailStore,
                  meta: {
                    requiresAuth: true,
                    title: "Store Detail",
                    privilege: STORE.BROWSE
                  }
                },
                {
                  path: "edit",
                  name: STORE.DETAIL.UPDATE,
                  component: StoreUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Edit",
                    privilege: STORE.BROWSE
                  }
                },
                {
                  path: "rates/update-page",
                  name: STORE.MARKETING_SCHEME.UPDATE,
                  component: StoreMarketingSchemeUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Update",
                    privilege: STORE.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/store-groups",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Store Groups"
          },
          children: [
            {
              path: "",
              name: STORE.GROUP.BROWSE,
              component: StoreGroups,
              meta: {
                requiresAuth: true,
                title: "Store Groups",
                privilege: STORE.GROUP.BROWSE
              }
            },
            {
              path: ":storeGroupId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Store Group",
                bcDynamic: true,
                bcType: "detail-store-groups"
              },
              children: [
                {
                  path: "",
                  name: STORE.GROUP.DETAIL,
                  component: StoreGroupsDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Store Group",
                    privilege: STORE.GROUP.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/companies",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Company"
          },
          children: [
            {
              path: "",
              name: COMPANIES.BROWSE,
              component: Company,
              meta: {
                requiresAuth: true,
                title: "Company",
                privilege: COMPANIES.BROWSE
              }
            },
            {
              path: ":companyId",
              name: COMPANIES.DETAIL,
              component: DetailCompany,
              meta: {
                requiresAuth: true,
                title: "Detail",
                privilege: COMPANIES.BROWSE,
                bcDynamic: true,
                bcType: "detail-company"
              }
            }
          ]
        },
        {
          path: "/financial-scheme",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Financial Scheme"
          },
          children: [
            {
              path: "",
              name: FINANCIAL_SCHEME.ROOT,
              component: FinancialScheme,
              meta: {
                requiresAuth: true,
                title: "Financial Scheme",
                privilege: FINANCIAL_SCHEME.ROOT
              }
            },
            {
              path: "create",
              name: FINANCIAL_SCHEME.CREATE,
              component: CreateFinancialScheme,
              meta: {
                requiresAuth: true,
                title: "Add",
                privilege: FINANCIAL_SCHEME.ROOT
              }
            },
            {
              path: ":financialSchemeId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-financial-scheme"
              },
              children: [
                {
                  path: "",
                  name: FINANCIAL_SCHEME.DETAIL,
                  component: DetailFinancialScheme,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: FINANCIAL_SCHEME.ROOT
                  }
                },
                {
                  path: "update",
                  name: FINANCIAL_SCHEME.UPDATE,
                  component: CreateFinancialScheme,
                  meta: {
                    requiresAuth: true,
                    title: "Edit",
                    privilege: FINANCIAL_SCHEME.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/financial-scheme-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Financial Scheme NMC"
          },
          children: [
            {
              path: "",
              name: NMC.FINANCIAL_SCHEME.BROWSE,
              component: FinancialScheme,
              meta: {
                requiresAuth: true,
                title: "Financial Scheme NMC",
                privilege: NMC.FINANCIAL_SCHEME.BROWSE
              }
            },
            {
              path: "create",
              name: NMC.FINANCIAL_SCHEME.CREATE,
              component: CreateFinancialSchemeNMC,
              meta: {
                requiresAuth: true,
                title: "Add",
                privilege: NMC.FINANCIAL_SCHEME.BROWSE
              }
            },
            {
              path: ":financialSchemeId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-financial-scheme-nmc"
              },
              children: [
                {
                  path: "",
                  name: NMC.FINANCIAL_SCHEME.DETAIL,
                  component: DetailFinancialScheme,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: NMC.FINANCIAL_SCHEME.BROWSE
                  }
                },
                {
                  path: "update",
                  name: NMC.FINANCIAL_SCHEME.UPDATE,
                  component: CreateFinancialSchemeNMC,
                  meta: {
                    requiresAuth: true,
                    title: "Edit",
                    privilege: NMC.FINANCIAL_SCHEME.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/branch",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Branch"
          },
          children: [
            {
              path: "",
              name: BRANCH.ROOT,
              component: Branch,
              meta: {
                requiresAuth: true,
                title: "Branch",
                privilege: BRANCH.ROOT
              }
            },
            {
              path: "create",
              name: BRANCH.CREATE,
              component: CreateBranch,
              meta: {
                requiresAuth: true,
                title: "Tambah",
                privilege: BRANCH.ROOT
              }
            },
            {
              path: "import",
              name: BRANCH.IMPORT,
              component: ImportBranch,
              meta: {
                requiresAuth: true,
                title: "Import",
                privilege: BRANCH.ROOT
              }
            },
            {
              path: "import-bulk",
              name: BRANCH.IMPORT_BULK,
              component: ImportBranchBulk,
              meta: {
                requiresAuth: true,
                title: "Import",
                privilege: BRANCH.ROOT
              }
            },
            {
              path: ":branchId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-branch"
              },
              children: [
                {
                  path: "",
                  name: BRANCH.DETAIL.ROOT,
                  component: DetailBranch,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: BRANCH.ROOT
                  }
                },
                {
                  path: ":rateId/create-exclusive-page",
                  name: BRANCH.RATE.EXCLUSIVE_RATE.CREATE,
                  component: CreateBranchExclusiveRate,
                  meta: {
                    requiresAuth: true,
                    title: "Add Exclusive Rate",
                    privilege: BRANCH.ROOT
                  }
                },
                {
                  path: ":rateId/update-exclusive-page",
                  name: BRANCH.RATE.EXCLUSIVE_RATE.UPDATE,
                  component: CreateBranchExclusiveRate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Exclusive Rate",
                    privilege: BRANCH.ROOT
                  }
                },
                {
                  path: "rates",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    title: "Rates",
                    privilege: BRANCH.ROOT
                  },
                  children: [
                    {
                      path: "",
                      name: BRANCH.RATE.ROOT,
                      component: BranchRate,
                      meta: {
                        requiresAuth: true,
                        title: "Rates",
                        privilege: BRANCH.ROOT
                      }
                    },
                    {
                      path: "create",
                      name: BRANCH.RATE.CREATE,
                      component: CreateBranchRate,
                      meta: {
                        requiresAuth: true,
                        title: "Add Rate",
                        privilege: BRANCH.ROOT
                      }
                    },
                    {
                      path: ":rateId",
                      component: {
                        render(c) {
                          return c("router-view");
                        }
                      },
                      meta: {
                        requiresAuth: true,
                        title: "Detail",
                        bcDynamic: true,
                        bcType: "detail-branch-rate"
                      },
                      children: [
                        {
                          path: "",
                          name: BRANCH.RATE.DETAIL.ROOT,
                          component: DetailBranchRate,
                          meta: {
                            requiresAuth: true,
                            title: "Detail",
                            privilege: BRANCH.ROOT
                          }
                        },
                        {
                          path: "update",
                          name: BRANCH.RATE.DETAIL.UPDATE,
                          component: CreateBranchRate,
                          meta: {
                            requiresAuth: true,
                            title: "Edit Rate",
                            privilege: BRANCH.ROOT
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  path: "fees",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    title: "Fees",
                    privilege: BRANCH.ROOT
                  },
                  children: [
                    {
                      path: "",
                      name: BRANCH.FEE.ROOT,
                      component: BranchFee,
                      meta: {
                        requiresAuth: true,
                        title: "Fees",
                        privilege: BRANCH.ROOT
                      }
                    },
                    {
                      path: "create",
                      name: BRANCH.FEE.CREATE,
                      component: CreateBranchFee,
                      meta: {
                        requiresAuth: true,
                        title: "Add Fee",
                        privilege: BRANCH.ROOT
                      }
                    },
                    {
                      path: ":feeId",
                      component: {
                        render(c) {
                          return c("router-view");
                        }
                      },
                      meta: {
                        requiresAuth: true,
                        title: "Detail",
                        bcDynamic: true,
                        bcType: "detail-branch-fee"
                      },
                      children: [
                        {
                          path: "",
                          name: BRANCH.FEE.DETAIL.ROOT,
                          component: DetailBranchFee,
                          meta: {
                            requiresAuth: true,
                            title: "Detail",
                            privilege: BRANCH.ROOT
                          }
                        },
                        {
                          path: "update",
                          name: BRANCH.FEE.DETAIL.UPDATE,
                          component: CreateBranchFee,
                          meta: {
                            requiresAuth: true,
                            title: "Edit Fee",
                            privilege: BRANCH.ROOT
                          }
                        },
                        {
                          path: "exclusive",
                          name: BRANCH.FEE.DETAIL.EXCLUSIVE.ROOT,
                          component: CreateBranchExclusive,
                          meta: {
                            requiresAuth: true,
                            title: "Add Exclusive Fee",
                            privilege: BRANCH.ROOT
                          }
                        },
                        {
                          path: "exclusive-update",
                          name: BRANCH.FEE.DETAIL.EXCLUSIVE.UPDATE,
                          component: CreateBranchExclusive,
                          meta: {
                            requiresAuth: true,
                            title: "Update Exclusive Fee",
                            privilege: BRANCH.ROOT
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: "/national-membership",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Daftar Anggota Nasional"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.NATIONAL.ROOT,
              component: Membership,
              meta: {
                requiresAuth: true,
                title: "Daftar Anggota Nasional",
                privilege: MEMBERSHIP.NATIONAL.ROOT
              }
            },
            {
              path: ":memberId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Anggota Nasional",
                bcDynamic: true,
                bcType: "detail-member"
              },
              children: [
                {
                  path: "",
                  name: MEMBERSHIP.NATIONAL.DETAIL,
                  component: DetailMembership,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Anggota",
                    privilege: MEMBERSHIP.NATIONAL.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/membership-silo",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Membership Silo"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.SILO.ROOT,
              component: MembershipSilo,
              meta: {
                requiresAuth: true,
                title: "Membership Silo",
                privilege: MEMBERSHIP.SILO.ROOT
              }
            },
            // {
            //   path: "create",
            //   name: MEMBERSHIP.SILO.CREATE,
            //   component: MembershipSiloCreate,
            //   meta: {
            //     requiresAuth: true,
            //     title: "Tambah Membership Silo",
            //     privilege: MEMBERSHIP.SILO.ROOT
            //   }
            // },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-membership-silo"
              },
              children: [
                {
                  path: "",
                  name: MEMBERSHIP.SILO.DETAIL,
                  component: MembershipSiloDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Membership Silo",
                    privilege: MEMBERSHIP.SILO.ROOT
                  }
                }
                // {
                //   path: "update",
                //   name: MEMBERSHIP.SILO.UPDATE,
                //   component: MembershipSiloCreate,
                //   meta: {
                //     requiresAuth: true,
                //     title: "Update Membership Silo",
                //     privilege: MEMBERSHIP.SILO.ROOT
                //   }
                // }
              ]
            }
          ]
        },
        {
          path: "/replace-card-number",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Replace Card Number"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.REPLACE_CARD_NUMBER.ROOT,
              component: ReplaceCardNumber,
              meta: {
                requiresAuth: true,
                title: "Replace Card Number",
                privilege: MEMBERSHIP.REPLACE_CARD_NUMBER.ROOT
              }
            }
          ]
        },
        {
          path: "/token-management",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Token Management"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.EXTERNAL_SOURCE.ROOT,
              component: ExternalSource,
              meta: {
                requiresAuth: true,
                title: "Token Management",
                privilege: MEMBERSHIP.EXTERNAL_SOURCE.ROOT
              }
            },
            {
              path: "create",
              name: MEMBERSHIP.EXTERNAL_SOURCE.CREATE,
              component: ExternalSourceCreate,
              meta: {
                requiresAuth: true,
                title: "Create",
                privilege: MEMBERSHIP.EXTERNAL_SOURCE.ROOT
              }
            },
            {
              path: ":externalSourceId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail External Source",
                bcDynamic: true,
                bcType: "detail-external-source"
              },
              children: [
                {
                  path: "",
                  name: MEMBERSHIP.EXTERNAL_SOURCE.DETAIL,
                  component: ExternalSourceDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail External Source",
                    privilege: MEMBERSHIP.EXTERNAL_SOURCE.ROOT
                  }
                },
                {
                  path: "update",
                  name: MEMBERSHIP.EXTERNAL_SOURCE.UPDATE,
                  component: ExternalSourceCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Edit",
                    privilege: MEMBERSHIP.EXTERNAL_SOURCE.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/membership",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Daftar Anggota"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.BROWSE,
              component: Membership,
              meta: {
                requiresAuth: true,
                title: "Daftar Anggota",
                privilege: MEMBERSHIP.BROWSE
              }
            },
            {
              path: "create",
              name: MEMBERSHIP.CREATE,
              component: CreateMembership,
              meta: {
                requiresAuth: true,
                title: "Tambah Anggota",
                privilege: MEMBERSHIP.CREATE
              }
            },
            {
              path: "update",
              name: MEMBERSHIP.UPDATE,
              component: CreateMembership,
              meta: {
                requiresAuth: true,
                title: "Ubah Anggota",
                privilege: MEMBERSHIP.BROWSE
              }
            },
            {
              path: "reporting",
              name: MEMBERSHIP.REPORTING,
              component: ReportingMembership,
              meta: {
                requiresAuth: true,
                title: "Membership Reporting",
                privilege: MEMBERSHIP.REPORTING
              }
            },
            {
              path: ":memberId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Anggota",
                bcDynamic: true,
                bcType: "detail-member"
              },
              children: [
                {
                  path: "",
                  name: MEMBERSHIP.DETAIL.ROOT,
                  component: DetailMembership,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Anggota",
                    privilege: MEMBERSHIP.BROWSE
                  }
                },
                {
                  path: "risk-create",
                  name: MEMBERSHIP.DETAIL.RISK_CREATE,
                  component: CreateRiskProfile,
                  meta: {
                    requiresAuth: true,
                    title: "Create Risk Profile",
                    privilege: MEMBERSHIP.BROWSE
                  }
                },
                {
                  path: "risk-update-page/:riskId",
                  name: MEMBERSHIP.DETAIL.RISK_UPDATE,
                  component: CreateRiskProfile,
                  meta: {
                    requiresAuth: true,
                    title: "Update Risk Profile",
                    privilege: MEMBERSHIP.BROWSE
                  }
                },
                {
                  path: "risk-detail-page/:riskId",
                  name: MEMBERSHIP.DETAIL.RISK_DETAIL,
                  component: DetailRiskProfile,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Risk Profile",
                    privilege: MEMBERSHIP.BROWSE
                  }
                },
                {
                  path: "escrow-update-page/:escrowId",
                  name: MEMBERSHIP.DETAIL.ESCROW_UPDATE,
                  component: UpdateEscrow,
                  meta: {
                    requiresAuth: true,
                    title: "Update Escrow Status",
                    privilege: MEMBERSHIP.BROWSE
                  }
                },
                {
                  path: "escrow-detail-page/:escrowId",
                  name: MEMBERSHIP.DETAIL.ESCROW_DETAIL,
                  component: DetailEscrow,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Escrow Plafond & Status",
                    privilege: MEMBERSHIP.BROWSE
                  }
                },
                {
                  path: "escrow-balance-tracking-page/:escrowId",
                  name: MEMBERSHIP.DETAIL.ESCROW_BALANCE_TRACKING,
                  component: EscrowBalanceTracking,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Escrow Balance Tracking",
                    privilege: MEMBERSHIP.BROWSE
                  }
                },
                {
                  path: "document-update",
                  name: MEMBERSHIP.DETAIL.DOCUMENT_UPDATE,
                  component: CreateMembershipDocument,
                  meta: {
                    requiresAuth: true,
                    title: "Update Document",
                    privilege: MEMBERSHIP.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/import-membership",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Daftar Import Member"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.IMPORT.ROOT,
              component: ImportMembership,
              meta: {
                requiresAuth: true,
                title: "Daftar Import Member",
                privilege: MEMBERSHIP.IMPORT.ROOT
              }
            },
            {
              path: "create",
              name: MEMBERSHIP.IMPORT.CREATE,
              component: CreateImportMembership,
              meta: {
                requiresAuth: true,
                title: "Import Data Member",
                privilege: MEMBERSHIP.IMPORT.ROOT
              }
            },
            {
              path: "update",
              name: MEMBERSHIP.IMPORT.UPDATE,
              component: CreateImportMembership,
              meta: {
                requiresAuth: true,
                title: "Import Data Member",
                privilege: MEMBERSHIP.IMPORT.ROOT
              }
            },
            {
              path: ":importMemberId",
              name: MEMBERSHIP.IMPORT.DETAIL,
              component: DetailImportMembership,
              meta: {
                requiresAuth: true,
                title: "Detail Import Member",
                privilege: MEMBERSHIP.IMPORT.ROOT,
                bcDynamic: true,
                bcType: "detail-import-member"
              }
            }
          ]
        },
        {
          path: "/import-membership-employee",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Daftar Import Member Employee"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.IMPORT.EMPLOYEE.ROOT,
              component: ImportMembershipEmployee,
              meta: {
                requiresAuth: true,
                title: "Daftar Import Member Employee",
                privilege: MEMBERSHIP.IMPORT.EMPLOYEE.ROOT
              }
            },
            {
              path: "create",
              name: MEMBERSHIP.IMPORT.EMPLOYEE.CREATE,
              component: CreateImportMembershipEmployee,
              meta: {
                requiresAuth: true,
                title: "Import Data Member Employee",
                privilege: MEMBERSHIP.IMPORT.EMPLOYEE.ROOT
              }
            },
            {
              path: ":importMemberId",
              name: MEMBERSHIP.IMPORT.EMPLOYEE.DETAIL,
              component: DetailImportMembershipEmployee,
              meta: {
                requiresAuth: true,
                title: "Detail Import Member Employee",
                privilege: MEMBERSHIP.IMPORT.EMPLOYEE.ROOT,
                bcDynamic: true,
                bcType: "detail-import-member-employee"
              }
            }
          ]
        },
        {
          path: "/membership-employee",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Daftar Member Employee"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.EMPLOYEE.ROOT,
              component: MembershipEmployee,
              meta: {
                requiresAuth: true,
                title: "Daftar Member Employee",
                privilege: MEMBERSHIP.EMPLOYEE.ROOT
              }
            },
            {
              path: ":memberId",
              name: MEMBERSHIP.EMPLOYEE.DETAIL,
              component: DetailMembershipEmployee,
              meta: {
                requiresAuth: true,
                title: "Detail Import Member Employee",
                privilege: MEMBERSHIP.EMPLOYEE.ROOT,
                bcDynamic: true,
                bcType: "detail-member-employee"
              }
            }
          ]
        },
        {
          path: "/risk-profile-membership",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Daftar Risk Profile"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.RISK_PROFILE.ROOT,
              component: MembershipRiskProfile,
              meta: {
                requiresAuth: true,
                title: "Daftar Risk Profile",
                privilege: MEMBERSHIP.RISK_PROFILE.ROOT
              }
            }
          ]
        },
        {
          path: "/membership-database-type",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Setup Database Type"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.SETUP_DATABASE.ROOT,
              component: MembershipSetupForDatabase,
              meta: {
                requiresAuth: true,
                title: "Setup Database Type",
                privilege: MEMBERSHIP.SETUP_DATABASE.ROOT
              }
            },
            {
              path: "create",
              name: MEMBERSHIP.SETUP_DATABASE.CREATE,
              component: MembershipCreateSetupForDatabase,
              meta: {
                requiresAuth: true,
                title: "Create Setup Database Type",
                privilege: MEMBERSHIP.SETUP_DATABASE.CREATE
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Setup Database Type",
                bcDynamic: true,
                bcType: "detail-setup-database-type"
              },
              children: [
                {
                  path: "",
                  name: MEMBERSHIP.SETUP_DATABASE.DETAIL,
                  component: MembershipDetailSetupForDatabase,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Setup Database Type",
                    privilege: MEMBERSHIP.SETUP_DATABASE.ROOT
                  }
                },
                {
                  path: "update",
                  name: MEMBERSHIP.SETUP_DATABASE.UPDATE,
                  component: MembershipCreateSetupForDatabase,
                  meta: {
                    requiresAuth: true,
                    title: "Create Setup Database Type",
                    privilege: MEMBERSHIP.SETUP_DATABASE.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/membership-group",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Member Group"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.GROUP.ROOT,
              component: MembershipGroup,
              meta: {
                requiresAuth: true,
                title: "Member Group",
                privilege: MEMBERSHIP.GROUP.ROOT
              }
            },
            {
              path: "import",
              name: MEMBERSHIP.GROUP.IMPORT,
              component: ImportMembershipGroup,
              meta: {
                requiresAuth: true,
                title: "Import Member Group",
                privilege: MEMBERSHIP.GROUP.ROOT
              }
            },
            {
              path: "create",
              name: MEMBERSHIP.GROUP.CREATE,
              component: CreateMembershipGroup,
              meta: {
                requiresAuth: true,
                title: "Tambah Member Group",
                privilege: MEMBERSHIP.GROUP.ROOT
              }
            },
            {
              path: "create-mapping",
              name: MEMBERSHIP.GROUP.MAPPING.CREATE,
              component: CreateMembershipGroupMapping,
              meta: {
                requiresAuth: true,
                title: "Tambah Mapping Member",
                privilege: MEMBERSHIP.GROUP.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Member Group",
                bcDynamic: true,
                bcType: "update-member-group"
              },
              children: [
                {
                  path: "update",
                  name: MEMBERSHIP.GROUP.UPDATE,
                  component: CreateMembershipGroup,
                  meta: {
                    requiresAuth: true,
                    title: "Update",
                    privilege: MEMBERSHIP.GROUP.ROOT
                  }
                },
                {
                  path: ":memberId/update",
                  name: MEMBERSHIP.GROUP.MAPPING.UPDATE,
                  component: CreateMembershipGroupMapping,
                  meta: {
                    requiresAuth: true,
                    title: "Mapping",
                    privilege: MEMBERSHIP.GROUP.ROOT,
                    bcDynamic: true,
                    bcType: "update-member-group-mapping"
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/blacklist-phone-number",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Blacklist Phone Number"
          },
          children: [
            {
              path: "",
              name: MEMBERSHIP.BLACKLIST_PHONE_NO.ROOT,
              component: BlacklistPhoneNo,
              meta: {
                requiresAuth: true,
                title: "Blacklist Phone Number",
                privilege: MEMBERSHIP.BLACKLIST_PHONE_NO.ROOT
              }
            },
            {
              path: "create",
              name: MEMBERSHIP.BLACKLIST_PHONE_NO.CREATE,
              component: BlacklistPhoneNoCreate,
              meta: {
                requiresAuth: true,
                title: "Tambah Blacklist Phone Number",
                privilege: MEMBERSHIP.BLACKLIST_PHONE_NO.ROOT
              }
            },
            {
              path: "import",
              name: MEMBERSHIP.BLACKLIST_PHONE_NO.IMPORT_BULK,
              component: BlacklistPhoneNoImport,
              meta: {
                requiresAuth: true,
                title: "Import Blacklist Phone Number",
                privilege: MEMBERSHIP.BLACKLIST_PHONE_NO.ROOT
              }
            },
            {
              path: ":blacklistId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-blacklist-phone-number"
              },
              children: [
                {
                  path: "",
                  name: MEMBERSHIP.BLACKLIST_PHONE_NO.DETAIL,
                  component: BlacklistPhoneNoDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Blacklist Phone Number",
                    privilege: MEMBERSHIP.BLACKLIST_PHONE_NO.ROOT
                  }
                },
                {
                  path: "update",
                  name: MEMBERSHIP.BLACKLIST_PHONE_NO.UPDATE,
                  component: BlacklistPhoneNoCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Blacklist Phone Number",
                    privilege: MEMBERSHIP.BLACKLIST_PHONE_NO.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/qanun-branch",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Qanun Branch SPEKTRA"
          },
          children: [
            {
              path: "",
              name: QANUN_BRANCH.ROOT,
              component: QanunBranch,
              meta: {
                requiresAuth: true,
                title: "Qanun Branch SPEKTRA",
                privilege: QANUN_BRANCH.ROOT
              }
            },
            {
              path: "import",
              name: QANUN_BRANCH.IMPORT,
              component: ImportQanunBranch,
              meta: {
                requiresAuth: true,
                title: "Import",
                privilege: QANUN_BRANCH.ROOT
              }
            },
            {
              path: "create",
              name: QANUN_BRANCH.CREATE,
              component: CreateQanunBranch,
              meta: {
                requiresAuth: true,
                title: "Add",
                privilege: QANUN_BRANCH.ROOT
              }
            },
            {
              path: ":branchId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-qanun-branch"
              },
              children: [
                {
                  path: "",
                  name: QANUN_BRANCH.DETAIL,
                  component: DetailQanunBranch,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: QANUN_BRANCH.ROOT
                  }
                },
                {
                  path: "update",
                  name: QANUN_BRANCH.UPDATE,
                  component: CreateQanunBranch,
                  meta: {
                    requiresAuth: true,
                    title: "Edit",
                    privilege: QANUN_BRANCH.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/roles",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Roles"
          },
          children: [
            {
              path: "",
              name: ROLES.LIST,
              component: Roles,
              meta: {
                requiresAuth: true,
                title: "Daftar Role",
                privilege: ROLES.LIST
              }
            },
            {
              path: "create",
              name: ROLES.CREATE,
              component: AddRoles,
              meta: {
                requiresAuth: true,
                title: "Tambah Role",
                privilege: ROLES.LIST
              }
            },
            {
              path: "update",
              name: ROLES.UPDATE,
              component: AddRoles,
              meta: {
                requiresAuth: true,
                title: "Ubah Role",
                privilege: ROLES.LIST
              }
            },
            {
              path: "detail",
              name: ROLES.DETAIL,
              component: DetailRoles,
              meta: {
                requiresAuth: true,
                title: "Detail Role",
                privilege: ROLES.LIST
              }
            },
            {
              path: "update-page/:id",
              name: ROLES.RESTRICTION_EXPORT.UPDATE,
              component: RestrictionExport,
              meta: {
                requiresAuth: true,
                title: "Restriction Export",
                privilege: ROLES.LIST
              }
            }
          ]
        },
        {
          path: "/tracking-orders",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Order"
          },
          children: [
            {
              path: "",
              name: ORDERS.ROOT,
              component: OrderLog,
              meta: {
                requiresAuth: true,
                title: "Order",
                privilege: ORDERS.ROOT
              }
            }
          ]
        },
        {
          path: "/notification",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Notification Error"
          },
          children: [
            {
              path: "",
              name: NOTIFICATION_ERROR.ROOT,
              component: NotificationError,
              meta: {
                requiresAuth: true,
                title: "Notification Error",
                privilege: NOTIFICATION_ERROR.ROOT
              }
            },
            {
              path: "create",
              name: NOTIFICATION_ERROR.CREATE,
              component: NotificationErrorCreate,
              meta: {
                requiresAuth: true,
                title: "Create Notification Error",
                privilege: NOTIFICATION_ERROR.ROOT
              }
            },
            {
              path: ":notificationId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Notification Error",
                bcDynamic: true,
                bcType: "detail-notification-error"
              },
              children: [
                {
                  path: "",
                  name: NOTIFICATION_ERROR.DETAIL.ROOT,
                  component: NotificationErrorDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Notification Error",
                    privilege: NOTIFICATION_ERROR.ROOT
                  }
                },
                {
                  path: "update-page",
                  name: NOTIFICATION_ERROR.UPDATE,
                  component: NotificationErrorCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Notification Error",
                    privilege: NOTIFICATION_ERROR.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/card-reset-reason",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Card Reset Reason"
          },
          children: [
            {
              path: "",
              name: CARD_RESET_REASON.ROOT,
              component: CardResetReason,
              meta: {
                requiresAuth: true,
                title: "Card Reset Reason",
                privilege: CARD_RESET_REASON.ROOT
              }
            },
            {
              path: "create",
              name: CARD_RESET_REASON.CREATE,
              component: CardResetReasonCreate,
              meta: {
                requiresAuth: true,
                title: "Create",
                privilege: CARD_RESET_REASON.ROOT
              }
            },
            {
              path: ":cardResetReasonId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-card-reset-reason"
              },
              children: [
                {
                  path: "",
                  name: CARD_RESET_REASON.DETAIL.ROOT,
                  component: CardResetReasonDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: CARD_RESET_REASON.ROOT
                  }
                },
                {
                  path: "update",
                  name: CARD_RESET_REASON.UPDATE,
                  component: CardResetReasonCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update",
                    privilege: CARD_RESET_REASON.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/reason-delivery-return",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Reason For Delivery Return"
          },
          children: [
            {
              path: "",
              name: MASTER.REASON_FOR_RETURN.DELIVERY.ROOT,
              component: ReasonForDeliveryReturn,
              meta: {
                requiresAuth: true,
                title: "Reason For Delivery Return",
                privilege: MASTER.REASON_FOR_RETURN.DELIVERY.ROOT
              }
            },
            {
              path: "create",
              name: MASTER.REASON_FOR_RETURN.DELIVERY.CREATE,
              component: ReasonForDeliveryReturnCreate,
              meta: {
                requiresAuth: true,
                title: "Create",
                privilege: MASTER.REASON_FOR_RETURN.DELIVERY.ROOT
              }
            },
            {
              path: ":returnDeliveryId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Reason For Delivery Return Detail",
                bcDynamic: true,
                bcType: "detail-reason-delivery"
              },
              children: [
                {
                  path: "",
                  name: MASTER.REASON_FOR_RETURN.DELIVERY.DETAIL,
                  component: ReasonForDeliveryReturnDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Reason For Delivery Return Detail",
                    privilege: MASTER.REASON_FOR_RETURN.DELIVERY.ROOT
                  }
                },
                {
                  path: "update-page",
                  name: MASTER.REASON_FOR_RETURN.DELIVERY.UPDATE,
                  component: ReasonForDeliveryReturnCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update",
                    privilege: MASTER.REASON_FOR_RETURN.DELIVERY.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/reason-verification-return",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Reason For Verification Return"
          },
          children: [
            {
              path: "",
              name: MASTER.REASON_FOR_RETURN.VERIFICATION.ROOT,
              component: ReasonForVerificationReturn,
              meta: {
                requiresAuth: true,
                title: "Reason For Verification Return",
                privilege: MASTER.REASON_FOR_RETURN.VERIFICATION.ROOT
              }
            },
            {
              path: "create",
              name: MASTER.REASON_FOR_RETURN.VERIFICATION.CREATE,
              component: ReasonForVerificationReturnCreate,
              meta: {
                requiresAuth: true,
                title: "Create",
                privilege: MASTER.REASON_FOR_RETURN.VERIFICATION.ROOT
              }
            },
            {
              path: ":returnVerificationId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Reason For Verification Return Detail",
                bcDynamic: true,
                bcType: "detail-reason-verification"
              },
              children: [
                {
                  path: "",
                  name: MASTER.REASON_FOR_RETURN.VERIFICATION.DETAIL,
                  component: ReasonForVerificationReturnDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Reason For Verification Return Detail",
                    privilege: MASTER.REASON_FOR_RETURN.VERIFICATION.ROOT
                  }
                },
                {
                  path: "update-page",
                  name: MASTER.REASON_FOR_RETURN.VERIFICATION.UPDATE,
                  component: ReasonForVerificationReturnCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update",
                    privilege: MASTER.REASON_FOR_RETURN.VERIFICATION.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/app-setting-properties",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "App Setting Properties"
          },
          children: [
            {
              path: "",
              name: SETTING_PROPERTIES.ROOT,
              component: AppSettingProperties,
              meta: {
                requiresAuth: true,
                title: "App Setting Properties",
                privilege: SETTING_PROPERTIES.ROOT
              }
            },
            {
              path: "create",
              name: SETTING_PROPERTIES.CREATE,
              component: AppSettingPropertiesCreate,
              meta: {
                requiresAuth: true,
                title: "Create App Setting Properties",
                privilege: SETTING_PROPERTIES.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail App Setting Properties",
                bcDynamic: true,
                bcType: "detail-app-setting-properties"
              },
              children: [
                {
                  path: "",
                  name: SETTING_PROPERTIES.DETAIL,
                  component: AppSettingPropertiesDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail App Setting Properties",
                    privilege: SETTING_PROPERTIES.ROOT
                  }
                },
                {
                  path: "update",
                  name: SETTING_PROPERTIES.UPDATE,
                  component: AppSettingPropertiesCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update App Setting Properties",
                    privilege: SETTING_PROPERTIES.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/new-promo-nmc",
          name: NMC.PROMO.NEW,
          component: MasterPromoNMC,
          meta: {
            requiresAuth: true,
            title: "Promo New NMC",
            privilege: NMC.PROMO.NEW
          }
        },
        {
          path: "/promo-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Promo NMC Browse"
          },
          children: [
            {
              path: "",
              name: NMC.PROMO.BROWSE,
              component: MasterPromoNMC,
              meta: {
                requiresAuth: true,
                title: "Promo NMC",
                privilege: NMC.PROMO.BROWSE
              }
            },
            {
              path: ":promoId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Promo",
                bcDynamic: true,
                bcType: "detail-promo-nmc"
              },
              children: [
                {
                  path: "",
                  name: NMC.PROMO.DETAIL,
                  component: MasterPromoNMCDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Promo",
                    privilege: NMC.PROMO.BROWSE
                  }
                },
                {
                  path: "update",
                  name: NMC.PROMO.UPDATE,
                  component: MasterPromoNMCUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Promo",
                    privilege: NMC.PROMO.BROWSE
                  }
                },
                {
                  path: "import",
                  name: NMC.PROMO.IMPORT,
                  component: MasterPromoNMCImport,
                  meta: {
                    requiresAuth: true,
                    title: "Import Promo Rates",
                    privilege: NMC.PROMO.BROWSE
                  }
                },
                {
                  path: "update-page/:updateRatesId",
                  name: NMC.PROMO.UPDATE_RATE,
                  component: MasterPromoNMCRatesUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Edit Rates",
                    privilege: NMC.PROMO.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/dealer-nmc-sf",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Dealer CS Browse"
          },
          children: [
            {
              path: "",
              name: NMC.DEALER_MAPPING_SF.BROWSE,
              component: MasterDealerNMCSF,
              meta: {
                requiresAuth: true,
                title: "Dealer CS",
                privilege: NMC.DEALER_MAPPING_SF.BROWSE
              }
            },
            {
              path: "import",
              name: NMC.DEALER_MAPPING_SF.IMPORT,
              component: MasterDealerNMCSFImport,
              meta: {
                requiresAuth: true,
                title: "Import Dealer CS",
                privilege: NMC.DEALER_MAPPING_SF.BROWSE
              }
            }
          ]
        },
        {
          path: "/new-dealer-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Dealer Browse"
          },
          children: [
            {
              path: "",
              name: NMC.NEW_DEALER.BROWSE,
              component: MasterDealerNMC,
              meta: {
                requiresAuth: true,
                title: "Dealer",
                privilege: NMC.NEW_DEALER.BROWSE
              }
            }
          ]
        },
        {
          path: "/dealer-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Dealer Browse"
          },
          children: [
            {
              path: "",
              name: NMC.DEALER.BROWSE,
              component: MasterDealerNMC,
              meta: {
                requiresAuth: true,
                title: "Dealer",
                privilege: NMC.DEALER.BROWSE
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Dealer",
                bcDynamic: true,
                bcType: "detail-master-nmc"
              },
              children: [
                {
                  path: "",
                  name: NMC.DEALER.DETAIL,
                  component: MasterDealerNMCDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Dealer",
                    privilege: NMC.DEALER.BROWSE
                  }
                },
                {
                  path: "update",
                  name: NMC.DEALER.UPDATE,
                  component: MasterDealerNMCCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Dealer NMC",
                    privilege: NMC.DEALER.BROWSE
                  }
                },
                {
                  path: ":marketingSchemeId/update-page",
                  name: NMC.DEALER.MARKETING_SCHEME.UPDATE,
                  component: MasterUpdateMarketingSchemeDealer,
                  meta: {
                    requiresAuth: true,
                    title: "Update",
                    privilege: NMC.DEALER.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/exclusive-dealer-admin",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Exclusive Dealer Admin"
          },
          children: [
            {
              path: "",
              name: NMC.EXCLUSIVE_DEALER_ADMIN.BROWSE,
              component: MasterExclusiveDealerAdmin,
              meta: {
                requiresAuth: true,
                title: "Exclusive Dealer Admin Browse",
                privilege: NMC.EXCLUSIVE_DEALER_ADMIN.BROWSE
              }
            },
            {
              path: "create",
              name: NMC.EXCLUSIVE_DEALER_ADMIN.CREATE,
              component: MasterCreateExclusiveDealerAdmin,
              meta: {
                requiresAuth: true,
                title: "Tambah",
                privilege: NMC.EXCLUSIVE_DEALER_ADMIN.BROWSE
              }
            },
            {
              path: "update-page/:exclusiveDealerId",
              name: NMC.EXCLUSIVE_DEALER_ADMIN.UPDATE,
              component: MasterCreateExclusiveDealerAdmin,
              meta: {
                requiresAuth: true,
                title: "Update",
                privilege: NMC.EXCLUSIVE_DEALER_ADMIN.BROWSE
              }
            },
            {
              path: "import",
              name: NMC.EXCLUSIVE_DEALER_ADMIN.IMPORT,
              component: MasterImportExclusiveDealerAdmin,
              meta: {
                requiresAuth: true,
                title: "Import",
                privilege: NMC.EXCLUSIVE_DEALER_ADMIN.BROWSE
              }
            },
            {
              path: ":exclusiveDealerId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Exclusive Dealer Admin",
                bcDynamic: true,
                bcType: "detail-exclusive-dealer-admin"
              },
              children: [
                {
                  path: "",
                  name: NMC.EXCLUSIVE_DEALER_ADMIN.DETAIL,
                  component: MasterExclusiveDealerAdminDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Exclusive Dealer Admin",
                    privilege: NMC.EXCLUSIVE_DEALER_ADMIN.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/exclusive-dealer-rate",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Exclusive Dealer Rate"
          },
          children: [
            {
              path: "",
              name: NMC.EXCLUSIVE_DEALER_RATE.BROWSE,
              component: MasterExclusiveDealerRate,
              meta: {
                requiresAuth: true,
                title: "Exclusive Dealer Rate Browse",
                privilege: NMC.EXCLUSIVE_DEALER_RATE.BROWSE
              }
            },
            {
              path: "create",
              name: NMC.EXCLUSIVE_DEALER_RATE.CREATE,
              component: MasterCreateExclusiveDealerRate,
              meta: {
                requiresAuth: true,
                title: "Tambah",
                privilege: NMC.EXCLUSIVE_DEALER_RATE.BROWSE
              }
            },
            {
              path: "update-page/:exclusiveDealerId",
              name: NMC.EXCLUSIVE_DEALER_RATE.UPDATE,
              component: MasterCreateExclusiveDealerRate,
              meta: {
                requiresAuth: true,
                title: "Update",
                privilege: NMC.EXCLUSIVE_DEALER_RATE.BROWSE
              }
            },
            {
              path: "import",
              name: NMC.EXCLUSIVE_DEALER_RATE.IMPORT,
              component: MasterImportExclusiveDealerRate,
              meta: {
                requiresAuth: true,
                title: "Import",
                privilege: NMC.EXCLUSIVE_DEALER_RATE.BROWSE
              }
            },
            {
              path: ":exclusiveDealerId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Exclusive Rate",
                bcDynamic: true,
                bcType: "detail-exclusive-dealer-rate"
              },
              children: [
                {
                  path: "",
                  name: NMC.EXCLUSIVE_DEALER_RATE.DETAIL,
                  component: MasterExclusiveDealerRateDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Exclusive Dealer Rate",
                    privilege: NMC.EXCLUSIVE_DEALER_RATE.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/master-branch-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Daftar Branch NMC"
          },
          children: [
            {
              path: "",
              name: NMC.BRANCH.BROWSE,
              component: MasterBranchNMC,
              meta: {
                requiresAuth: true,
                title: "Branch",
                privilege: NMC.BRANCH.BROWSE
              }
            },
            {
              path: "create",
              name: NMC.BRANCH.CREATE,
              component: MasterCreateBranchNMC,
              meta: {
                requiresAuth: true,
                title: "Tambah",
                privilege: NMC.BRANCH.BROWSE
              }
            },
            {
              path: "import",
              name: NMC.BRANCH.IMPORT,
              component: MasterImportBranchNMC,
              meta: {
                requiresAuth: true,
                title: "Import",
                privilege: NMC.BRANCH.BROWSE
              }
            },
            {
              path: "import-bulk",
              name: NMC.BRANCH.IMPORT_BULK,
              component: MasterImportBulkBranchNMC,
              meta: {
                requiresAuth: true,
                title: "Import",
                privilege: NMC.BRANCH.BROWSE
              }
            },
            {
              path: ":branchId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-nmc-branch"
              },
              children: [
                {
                  path: "",
                  name: NMC.BRANCH.DETAIL,
                  component: MasterDetailBranchNMC,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: NMC.BRANCH.BROWSE
                  }
                },
                {
                  path: ":rateId/create-exclusive-page",
                  name: NMC.BRANCH.EXCLUSIVE_RATE.CREATE,
                  component: MasterCreateExclusiveRateBranchNMC,
                  meta: {
                    requiresAuth: true,
                    title: "Add Exclusive Rate",
                    privilege: NMC.BRANCH.BROWSE
                  }
                },
                {
                  path: ":rateId/update-exclusive-page",
                  name: NMC.BRANCH.EXCLUSIVE_RATE.UPDATE,
                  component: MasterCreateExclusiveRateBranchNMC,
                  meta: {
                    requiresAuth: true,
                    title: "Update Exclusive Rate",
                    privilege: NMC.BRANCH.BROWSE
                  }
                },
                {
                  path: "rates",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    title: "Rates",
                    privilege: NMC.BRANCH.BROWSE
                  },
                  children: [
                    {
                      path: "",
                      name: NMC.BRANCH.RATE.ROOT,
                      component: MasterNMCBranchRate,
                      meta: {
                        requiresAuth: true,
                        title: "Rates",
                        privilege: NMC.BRANCH.BROWSE
                      }
                    },
                    {
                      path: "create",
                      name: NMC.BRANCH.RATE.CREATE,
                      component: MasterNMCCreateBranchRate,
                      meta: {
                        requiresAuth: true,
                        title: "Add Rate",
                        privilege: NMC.BRANCH.BROWSE
                      }
                    },
                    {
                      path: ":rateId",
                      component: {
                        render(c) {
                          return c("router-view");
                        }
                      },
                      meta: {
                        requiresAuth: true,
                        title: "Detail",
                        bcDynamic: true,
                        bcType: "detail-branch-nmc-rate"
                      },
                      children: [
                        {
                          path: "",
                          name: NMC.BRANCH.RATE.DETAIL,
                          component: MasterNMCDetailBranchRate,
                          meta: {
                            requiresAuth: true,
                            title: "Detail",
                            privilege: NMC.BRANCH.BROWSE
                          }
                        },
                        {
                          path: "update",
                          name: NMC.BRANCH.RATE.UPDATE,
                          component: MasterNMCCreateBranchRate,
                          meta: {
                            requiresAuth: true,
                            title: "Edit Rate",
                            privilege: NMC.BRANCH.BROWSE
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  path: "fees",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    title: "Fees",
                    privilege: NMC.BRANCH.BROWSE
                  },
                  children: [
                    {
                      path: "",
                      name: NMC.BRANCH.FEE.ROOT,
                      component: NMCMasterBranchFee,
                      meta: {
                        requiresAuth: true,
                        title: "Fees",
                        privilege: NMC.BRANCH.BROWSE
                      }
                    },
                    {
                      path: "create",
                      name: NMC.BRANCH.FEE.CREATE,
                      component: NMCMasterCreateBranchFee,
                      meta: {
                        requiresAuth: true,
                        title: "Add Fee",
                        privilege: NMC.BRANCH.BROWSE
                      }
                    },
                    {
                      path: ":feeId",
                      component: {
                        render(c) {
                          return c("router-view");
                        }
                      },
                      meta: {
                        requiresAuth: true,
                        title: "Detail",
                        bcDynamic: true,
                        bcType: "detail-nmc-branch-fee"
                      },
                      children: [
                        {
                          path: "",
                          name: NMC.BRANCH.FEE.DETAIL,
                          component: MasterNMCDetailBranchFee,
                          meta: {
                            requiresAuth: true,
                            title: "Detail",
                            privilege: NMC.BRANCH.BROWSE
                          }
                        },
                        {
                          path: "update",
                          name: NMC.BRANCH.FEE.UPDATE,
                          component: NMCMasterCreateBranchFee,
                          meta: {
                            requiresAuth: true,
                            title: "Edit Fee",
                            privilege: NMC.BRANCH.BROWSE
                          }
                        },
                        {
                          path: "exclusive",
                          name: NMC.BRANCH.FEE.EXCLUSIVE.CREATE,
                          component: MasterNMCCreateBranchExclusive,
                          meta: {
                            requiresAuth: true,
                            title: "Add Exclusive Fee",
                            privilege: NMC.BRANCH.BROWSE
                          }
                        },
                        {
                          path: "exclusive-update",
                          name: NMC.BRANCH.FEE.EXCLUSIVE.UPDATE,
                          component: MasterNMCCreateBranchExclusive,
                          meta: {
                            requiresAuth: true,
                            title: "Update Exclusive Fee",
                            privilege: NMC.BRANCH.BROWSE
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: "/master-qanun-branch-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Qanun Branch NMC"
          },
          children: [
            {
              path: "",
              name: NMC.QANUN_BRANCH.ROOT,
              component: QanunBranch,
              meta: {
                requiresAuth: true,
                title: "Qanun Branch NMC",
                privilege: NMC.QANUN_BRANCH.ROOT
              }
            },
            {
              path: "import",
              name: NMC.QANUN_BRANCH.IMPORT,
              component: ImportQanunBranch,
              meta: {
                requiresAuth: true,
                title: "Import",
                privilege: NMC.QANUN_BRANCH.ROOT
              }
            },
            {
              path: "create",
              name: NMC.QANUN_BRANCH.CREATE,
              component: CreateQanunBranch,
              meta: {
                requiresAuth: true,
                title: "Add",
                privilege: NMC.QANUN_BRANCH.ROOT
              }
            },
            {
              path: ":branchId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-qanun-branch-nmc"
              },
              children: [
                {
                  path: "",
                  name: NMC.QANUN_BRANCH.DETAIL,
                  component: DetailQanunBranch,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: NMC.QANUN_BRANCH.ROOT
                  }
                },
                {
                  path: "update",
                  name: NMC.QANUN_BRANCH.UPDATE,
                  component: CreateQanunBranch,
                  meta: {
                    requiresAuth: true,
                    title: "Edit",
                    privilege: NMC.QANUN_BRANCH.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/master-branch-nmc-promo-fee",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Promo Fee & Admin Murni"
          },
          children: [
            {
              path: "",
              name: NMC.PROMO_FEE.BROWSE,
              component: MasterBranchPromoNMC,
              meta: {
                requiresAuth: true,
                title: "Branch",
                privilege: NMC.PROMO_FEE.BROWSE
              }
            },
            {
              path: "reset",
              name: NMC.PROMO_FEE.RESET,
              component: MasterResetBranchPromoNMC,
              meta: {
                requiresAuth: true,
                title: "Reset",
                privilege: NMC.PROMO_FEE.BROWSE
              }
            },
            {
              path: "import-bulk",
              name: NMC.PROMO_FEE.IMPORT_BULK,
              component: MasterImportBulkBranchPromoNMC,
              meta: {
                requiresAuth: true,
                title: "Import",
                privilege: NMC.PROMO_FEE.BROWSE
              }
            }
          ]
        },
        {
          path: "/product-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Product NMC"
          },
          children: [
            {
              path: "",
              name: NMC.PRODUCT.BROWSE,
              component: MasterProductNMC,
              meta: {
                requiresAuth: true,
                title: "Product NMC",
                privilege: NMC.PRODUCT.BROWSE
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Product NMC",
                bcDynamic: true,
                bcType: "detail-product-nmc"
              },
              children: [
                {
                  path: "",
                  name: NMC.PRODUCT.DETAIL,
                  component: MasterProductNMCDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Product NMC",
                    privilege: NMC.PRODUCT.BROWSE
                  }
                },
                {
                  path: "update",
                  name: NMC.PRODUCT.UPDATE,
                  component: MasterProductNMCUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Product NMC",
                    privilege: NMC.PRODUCT.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/product-group-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Product Group NMC"
          },
          children: [
            {
              path: "",
              name: NMC.PRODUCT.GROUP.BROWSE,
              component: ProductGroupNMC,
              meta: {
                requiresAuth: true,
                title: "Product Group NMC List",
                privilege: NMC.PRODUCT.GROUP.BROWSE
              }
            },
            {
              path: "update-page/:productGroupId",
              name: NMC.PRODUCT.GROUP.UPDATE,
              component: ProductGroupNMCUpdate,
              meta: {
                requiresAuth: true,
                title: "Product Group NMC Update",
                privilege: NMC.PRODUCT.GROUP.BROWSE,
                bcDynamic: true,
                bcType: "product-group-nmc-id"
              }
            },
            {
              path: ":productGroupId",
              name: NMC.PRODUCT.GROUP.DETAIL,
              component: DetailProductGroupNMC,
              meta: {
                requiresAuth: true,
                title: "Product Group NMC Detail",
                privilege: NMC.PRODUCT.GROUP.BROWSE,
                bcDynamic: true,
                bcType: "product-group-nmc-id"
              }
            }
          ]
        },
        {
          path: "/master-insurance-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Insurance NMC"
          },
          children: [
            {
              path: "",
              name: NMC.INSURANCE.BROWSE,
              component: MasterInsuranceNMC,
              meta: {
                requiresAuth: true,
                title: "Insurance NMC",
                privilege: NMC.INSURANCE.BROWSE
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Insurance NMC",
                bcDynamic: true,
                bcType: "detail-master-product-insurance-nmc"
              },
              children: [
                {
                  path: "",
                  name: NMC.INSURANCE.DETAIL,
                  component: MasterInsuranceNMCDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Insurance NMC",
                    privilege: NMC.INSURANCE.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/product-insurance-nmc",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Insurance Product NMC"
          },
          children: [
            {
              path: "",
              name: NMC.PRODUCT.INSURANCE.ROOT,
              component: ProductInsuranceNMC,
              meta: {
                requiresAuth: true,
                title: "Insurance Product NMC",
                privilege: NMC.PRODUCT.INSURANCE.ROOT
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Insurance Product NMC",
                bcDynamic: true,
                bcType: "detail-product-insurance-nmc"
              },
              children: [
                {
                  path: "",
                  name: NMC.PRODUCT.INSURANCE.DETAIL,
                  component: ProductInsuranceNMCDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Insurance Product NMC",
                    privilege: NMC.PRODUCT.INSURANCE.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/master-branch-ufi",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Daftar Branch UFI"
          },
          children: [
            {
              path: "",
              name: UFI.BRANCH.BROWSE,
              component: MasterBranchUFI,
              meta: {
                requiresAuth: true,
                title: "Branch",
                privilege: UFI.BRANCH.BROWSE
              }
            },
            {
              path: "create",
              name: UFI.BRANCH.CREATE,
              component: MasterCreateBranchUFI,
              meta: {
                requiresAuth: true,
                title: "Tambah",
                privilege: UFI.BRANCH.BROWSE
              }
            },
            {
              path: "import",
              name: UFI.BRANCH.IMPORT,
              component: MasterImportBranchUFI,
              meta: {
                requiresAuth: true,
                title: "Import",
                privilege: UFI.BRANCH.BROWSE
              }
            },
            {
              path: ":branchId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail",
                bcDynamic: true,
                bcType: "detail-ufi-branch"
              },
              children: [
                {
                  path: "",
                  name: UFI.BRANCH.DETAIL,
                  component: MasterDetailBranchUFI,
                  meta: {
                    requiresAuth: true,
                    title: "Detail",
                    privilege: UFI.BRANCH.BROWSE
                  }
                },
                {
                  path: ":rateId/create-exclusive-page",
                  name: UFI.BRANCH.EXCLUSIVE_RATE.CREATE,
                  component: MasterCreateExclusiveRateBranchUFI,
                  meta: {
                    requiresAuth: true,
                    title: "Add Exclusive Rate",
                    privilege: UFI.BRANCH.BROWSE
                  }
                },
                {
                  path: ":rateId/update-exclusive-page",
                  name: UFI.BRANCH.EXCLUSIVE_RATE.UPDATE,
                  component: MasterCreateExclusiveRateBranchUFI,
                  meta: {
                    requiresAuth: true,
                    title: "Update Exclusive Rate",
                    privilege: UFI.BRANCH.BROWSE
                  }
                },
                {
                  path: "rates",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    title: "Rates",
                    privilege: UFI.BRANCH.BROWSE
                  },
                  children: [
                    {
                      path: "",
                      name: UFI.BRANCH.RATE.ROOT,
                      component: MasterUFIBranchRate,
                      meta: {
                        requiresAuth: true,
                        title: "Rates",
                        privilege: UFI.BRANCH.BROWSE
                      }
                    },
                    {
                      path: "create",
                      name: UFI.BRANCH.RATE.CREATE,
                      component: MasterUFICreateBranchRate,
                      meta: {
                        requiresAuth: true,
                        title: "Add Rate",
                        privilege: UFI.BRANCH.BROWSE
                      }
                    },
                    {
                      path: ":rateId",
                      component: {
                        render(c) {
                          return c("router-view");
                        }
                      },
                      meta: {
                        requiresAuth: true,
                        title: "Detail",
                        bcDynamic: true,
                        bcType: "detail-branch-ufi-rate"
                      },
                      children: [
                        {
                          path: "",
                          name: UFI.BRANCH.RATE.DETAIL,
                          component: MasterUFIDetailBranchRate,
                          meta: {
                            requiresAuth: true,
                            title: "Detail",
                            privilege: UFI.BRANCH.BROWSE
                          }
                        },
                        {
                          path: "update",
                          name: UFI.BRANCH.RATE.UPDATE,
                          component: MasterUFICreateBranchRate,
                          meta: {
                            requiresAuth: true,
                            title: "Edit Rate",
                            privilege: UFI.BRANCH.BROWSE
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  path: "fees",
                  component: {
                    render(c) {
                      return c("router-view");
                    }
                  },
                  meta: {
                    requiresAuth: true,
                    title: "Fees",
                    privilege: UFI.BRANCH.BROWSE
                  },
                  children: [
                    {
                      path: "",
                      name: UFI.BRANCH.FEE.ROOT,
                      component: UFIMasterBranchFee,
                      meta: {
                        requiresAuth: true,
                        title: "Fees",
                        privilege: UFI.BRANCH.BROWSE
                      }
                    },
                    {
                      path: "create",
                      name: UFI.BRANCH.FEE.CREATE,
                      component: UFIMasterCreateBranchFee,
                      meta: {
                        requiresAuth: true,
                        title: "Add Fee",
                        privilege: UFI.BRANCH.BROWSE
                      }
                    },
                    {
                      path: ":feeId",
                      component: {
                        render(c) {
                          return c("router-view");
                        }
                      },
                      meta: {
                        requiresAuth: true,
                        title: "Detail",
                        bcDynamic: true,
                        bcType: "detail-ufi-branch-fee"
                      },
                      children: [
                        {
                          path: "",
                          name: UFI.BRANCH.FEE.DETAIL,
                          component: MasterUFIDetailBranchFee,
                          meta: {
                            requiresAuth: true,
                            title: "Detail",
                            privilege: UFI.BRANCH.BROWSE
                          }
                        },
                        {
                          path: "update",
                          name: UFI.BRANCH.FEE.UPDATE,
                          component: UFIMasterCreateBranchFee,
                          meta: {
                            requiresAuth: true,
                            title: "Edit Fee",
                            privilege: UFI.BRANCH.BROWSE
                          }
                        },
                        {
                          path: "exclusive",
                          name: UFI.BRANCH.FEE.EXCLUSIVE.CREATE,
                          component: MasterUFICreateBranchExclusive,
                          meta: {
                            requiresAuth: true,
                            title: "Add Exclusive Fee",
                            privilege: UFI.BRANCH.BROWSE
                          }
                        },
                        {
                          path: "exclusive-update",
                          name: UFI.BRANCH.FEE.EXCLUSIVE.UPDATE,
                          component: MasterUFICreateBranchExclusive,
                          meta: {
                            requiresAuth: true,
                            title: "Update Exclusive Fee",
                            privilege: UFI.BRANCH.BROWSE
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: "/new-dealer-ufi",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Dealer Browse"
          },
          children: [
            {
              path: "",
              name: UFI.NEW_DEALER.BROWSE,
              component: MasterDealerUFI,
              meta: {
                requiresAuth: true,
                title: "Dealer",
                privilege: UFI.NEW_DEALER.BROWSE
              }
            }
          ]
        },
        {
          path: "/dealer-ufi",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Dealer Browse"
          },
          children: [
            {
              path: "",
              name: UFI.DEALER.BROWSE,
              component: MasterDealerUFI,
              meta: {
                requiresAuth: true,
                title: "Dealer",
                privilege: UFI.DEALER.BROWSE
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Dealer",
                bcDynamic: true,
                bcType: "detail-master-ufi"
              },
              children: [
                {
                  path: "",
                  name: UFI.DEALER.DETAIL,
                  component: MasterDealerUFIDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Dealer",
                    privilege: UFI.DEALER.BROWSE
                  }
                },
                {
                  path: "update",
                  name: UFI.DEALER.UPDATE,
                  component: MasterDealerUFICreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Dealer UFI",
                    privilege: UFI.DEALER.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/master-kios",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Master Kios Browse"
          },
          children: [
            {
              path: "",
              name: UFI.KIOSK.BROWSE,
              component: MasterKioskUFI,
              meta: {
                requiresAuth: true,
                title: "Master Kios Browse",
                privilege: UFI.KIOSK.BROWSE
              }
            },
            {
              path: ":kioskId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Kios",
                bcDynamic: true,
                bcType: "detail-kiosk-ufi"
              },
              children: [
                {
                  path: "",
                  name: UFI.KIOSK.DETAIL,
                  component: MasterKioskUFIDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Kios UFI",
                    privilege: UFI.KIOSK.BROWSE
                  }
                },
                {
                  path: "update",
                  name: UFI.KIOSK.UPDATE,
                  component: MasterKioskUFIUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Kios UFI",
                    privilege: UFI.KIOSK.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/new-promo-ufi",
          name: UFI.PROMO.NEW,
          component: PromoUFI,
          meta: {
            requiresAuth: true,
            title: "Promo UFI New",
            privilege: PROMO.BROWSE,
            flag: {
              name: "New",
              secureId: "new"
            }
          }
        },
        {
          path: "/promo-ufi",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Promo UFI Browse"
          },
          children: [
            {
              path: "",
              name: UFI.PROMO.BROWSE,
              component: PromoUFI,
              meta: {
                requiresAuth: true,
                title: "Promo UFI",
                privilege: UFI.PROMO.BROWSE
              }
            },
            {
              path: "update-bulk",
              name: UFI.PROMO.UPDATE_BULK,
              component: PromoUFIUpdateBulk,
              meta: {
                requiresAuth: true,
                title: "Update Bulk Promo",
                privilege: UFI.PROMO.BROWSE
              }
            },
            {
              path: ":promoId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Promo UFI",
                bcDynamic: true,
                bcType: "detail-promo-ufi"
              },
              children: [
                {
                  path: "",
                  name: UFI.PROMO.DETAIL,
                  component: PromoUFIDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Promo UFI",
                    privilege: UFI.PROMO.BROWSE
                  }
                },
                {
                  path: "import",
                  name: UFI.PROMO.IMPORT,
                  component: PromoUFIImport,
                  meta: {
                    requiresAuth: true,
                    title: "Import Promo Rates",
                    privilege: UFI.PROMO.BROWSE
                  }
                },
                {
                  path: "update",
                  name: UFI.PROMO.UPDATE,
                  component: PromoUFIUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Promo",
                    privilege: UFI.PROMO.BROWSE
                  }
                },
                {
                  path: "update-page/:updateRatesId",
                  name: UFI.PROMO.UPDATE_RATE,
                  component: PromoUFIUpdateRate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Promo Rate",
                    privilege: UFI.PROMO.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/product-ufi",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Product UFI Browse"
          },
          children: [
            {
              path: "",
              name: UFI.OBJECT.BROWSE,
              component: ObjectUFI,
              meta: {
                requiresAuth: true,
                title: "Product UFI",
                privilege: UFI.OBJECT.BROWSE
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Product UFI",
                bcDynamic: true,
                bcType: "detail-object-ufi"
              },
              children: [
                {
                  path: "",
                  name: UFI.OBJECT.DETAIL,
                  component: ObjectUFIDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Product UFI",
                    privilege: UFI.OBJECT.BROWSE
                  }
                },
                {
                  path: "update",
                  name: UFI.OBJECT.UPDATE,
                  component: ObjectUFIUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Product UFI",
                    privilege: UFI.OBJECT.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/product-group-ufi",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Product Group UFI"
          },
          children: [
            {
              path: "",
              name: UFI.OBJECT.GROUP.BROWSE,
              component: ObjectGroupUFI,
              meta: {
                requiresAuth: true,
                title: "Product Group UFI List",
                privilege: UFI.OBJECT.GROUP.BROWSE
              }
            },
            {
              path: "update-page/:objectGroupId",
              name: UFI.OBJECT.GROUP.UPDATE,
              component: ObjectGroupUFIUpdate,
              meta: {
                requiresAuth: true,
                title: "Product Group UFI Update",
                privilege: UFI.OBJECT.GROUP.BROWSE,
                bcDynamic: true,
                bcType: "object-group-ufi-id"
              }
            },
            {
              path: ":objectGroupId",
              name: UFI.OBJECT.GROUP.DETAIL,
              component: ObjectGroupUFIDetail,
              meta: {
                requiresAuth: true,
                title: "Product Group UFI Detail",
                privilege: UFI.OBJECT.GROUP.BROWSE,
                bcDynamic: true,
                bcType: "object-group-ufi-id"
              }
            }
          ]
        },
        {
          path: "/audit-trail",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Audit Trail"
          },
          children: [
            {
              path: "",
              name: DEBUG.AUDIT_TRAIL.BROWSE,
              component: AuditTrail,
              meta: {
                requiresAuth: true,
                title: "Audit Trai",
                privilege: DEBUG.AUDIT_TRAIL.BROWSE
              }
            },
            {
              path: ":id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Audit Trail Detail",
                bcDynamic: true,
                bcType: "detail-audit-trail"
              },
              children: [
                {
                  path: "",
                  name: DEBUG.AUDIT_TRAIL.DETAIL,
                  component: AuditTrailDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Audit Trail Detail",
                    privilege: DEBUG.AUDIT_TRAIL.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/transaction-log",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Transaction Log"
          },
          children: [
            {
              path: "",
              name: DEBUG.LOG.BROWSE,
              component: TransactionLog,
              meta: {
                requiresAuth: true,
                title: "Transaction Log",
                privilege: DEBUG.LOG.BROWSE
              }
            },
            {
              path: "transaction-log-page/:id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Transaction Log Detail",
                bcDynamic: true,
                bcType: "detail-transaction-log"
              },
              children: [
                {
                  path: "",
                  name: DEBUG.LOG.DETAIL.TRANSACTION_LOG,
                  component: TransactionLogDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Transaction Log Detail",
                    privilege: DEBUG.LOG.BROWSE
                  }
                }
              ]
            },
            {
              path: "reject-log-page/:id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Reject Log Detail",
                bcDynamic: true,
                bcType: "detail-reject-log"
              },
              children: [
                {
                  path: "",
                  name: DEBUG.LOG.DETAIL.REJECT_LOG,
                  component: RejectLogDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Reject Log Detail",
                    privilege: DEBUG.LOG.BROWSE
                  }
                }
              ]
            },
            {
              path: "error-log-page/:id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Error Log Detail",
                bcDynamic: true,
                bcType: "detail-transaction-error-log"
              },
              children: [
                {
                  path: "",
                  name: DEBUG.LOG.DETAIL.TRANSACTION_ERROR_LOG,
                  component: ErrorLogDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Error Log Detail",
                    privilege: DEBUG.LOG.BROWSE
                  }
                }
              ]
            },
            {
              path: "otp-log-page/:id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "OTP Log Detail",
                bcDynamic: true,
                bcType: "detail-otp-log"
              },
              children: [
                {
                  path: "",
                  name: DEBUG.LOG.DETAIL.OTP_LOG,
                  component: OTPLogDetail,
                  meta: {
                    requiresAuth: true,
                    title: "OTP Log Detail",
                    privilege: DEBUG.LOG.BROWSE
                  }
                }
              ]
            },
            {
              path: "orderfull-page/:id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Orderfull Log Detail",
                bcDynamic: true,
                bcType: "detail-orderfull-log"
              },
              children: [
                {
                  path: "",
                  name: DEBUG.LOG.DETAIL.ORDERFULL_LOG,
                  component: OrderfullLogDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Orderfull Log Detail",
                    privilege: DEBUG.LOG.BROWSE
                  }
                }
              ]
            },
            {
              path: "scheduler-log-page/:id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Scheduler Log Detail",
                bcDynamic: true,
                bcType: "detail-scheduler-log"
              },
              children: [
                {
                  path: "",
                  name: DEBUG.LOG.DETAIL.SCHEDULER_LOG,
                  component: SchedulerLogDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Scheduler Log Detail",
                    privilege: DEBUG.LOG.BROWSE
                  }
                }
              ]
            },
            {
              path: "balance-tracking-log-page/:id",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Balance Tracking Log Detail",
                bcDynamic: true,
                bcType: "balance-tracking-log"
              },
              children: [
                {
                  path: "",
                  name: DEBUG.LOG.DETAIL.BALANCE_TRACKING_LOG,
                  component: BalanceTrackingLogDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Balance Tracking Log Detail",
                    privilege: DEBUG.LOG.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/update-sms-content",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Update SMS Content"
          },
          children: [
            {
              path: "",
              name: DEBUG.UPDATE_SMS_CONTENT.BROWSE,
              component: UpdateSMSContent,
              meta: {
                requiresAuth: true,
                title: "Update SMS Content",
                privilege: DEBUG.UPDATE_SMS_CONTENT.BROWSE
              }
            },
            {
              path: ":smsContentId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Update SMS Content",
                bcDynamic: true,
                bcType: "update-sms-content"
              },
              children: [
                {
                  path: "",
                  name: DEBUG.UPDATE_SMS_CONTENT.UPDATE,
                  component: UpdateSMSContentUpdate,
                  meta: {
                    requiresAuth: true,
                    title: "Update SMS Content",
                    privilege: DEBUG.UPDATE_SMS_CONTENT.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/family-financing",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Family Financing Content"
          },
          children: [
            {
              path: "",
              name: FAMILY_FINANCING.ROOT,
              component: FamilyFinancing,
              meta: {
                requiresAuth: true,
                title: "Update SMS Content",
                privilege: FAMILY_FINANCING.ROOT
              }
            },
            {
              path: ":familyFinancingId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Family Financing",
                bcDynamic: true,
                bcType: "detail-family-financing"
              },
              children: [
                {
                  path: "",
                  name: FAMILY_FINANCING.DETAIL,
                  component: FamilyFinancingDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Family Financing",
                    privilege: FAMILY_FINANCING.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/sao-assign",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Assignment"
          },
          children: [
            {
              path: "",
              name: MEDIATOR.SAO.BROWSE,
              component: MediatorSAO,
              meta: {
                requiresAuth: true,
                title: "Assignment",
                privilege: MEDIATOR.SAO.BROWSE
              }
            }
          ]
        },
        {
          path: "/regions",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Region"
          },
          children: [
            {
              path: "",
              name: REGIONS.ROOT,
              component: Region,
              meta: {
                requiresAuth: true,
                title: "Region Browse",
                privilege: PROGRAM_TYPE.ROOT
              }
            },
            {
              path: ":regionId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Region",
                bcDynamic: true,
                bcType: "detail-program-type"
              },
              children: [
                {
                  path: "",
                  name: REGIONS.DETAIL,
                  component: RegionDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Region",
                    privilege: PROGRAM_TYPE.ROOT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/about",
          name: ABOUT,
          component: About,
          meta: {
            requiresAuth: true,
            title: "About"
          }
        },
        {
          path: "/mediator",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Mediator Browse"
          },
          children: [
            {
              path: "",
              name: MEDIATOR.MEDIATOR.BROWSE,
              component: Mediator,
              meta: {
                requiresAuth: true,
                title: "Mediator Browse",
                privilege: MEDIATOR.MEDIATOR.BROWSE
              }
            }
          ]
        },
        {
          path: "/master-lob",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Master LOB"
          },
          children: [
            {
              path: "",
              name: MASTER_LOB.BROWSE,
              component: MasterLOB,
              meta: {
                requiresAuth: true,
                title: "Master LOB List",
                privilege: MASTER_LOB.BROWSE
              }
            },
            {
              path: ":lobId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Detail Master LOB",
                bcDynamic: true,
                bcType: "detail-master-lob"
              },
              children: [
                {
                  path: "",
                  name: MASTER_LOB.DETAIL,
                  component: MasterLOBDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Detail Master LOB",
                    privilege: MASTER_LOB.BROWSE
                  }
                },
                {
                  path: "update",
                  name: MASTER_LOB.UPDATE,
                  component: MasterLOBCreate,
                  meta: {
                    requiresAuth: true,
                    title: "Update Master LOB",
                    privilege: MASTER_LOB.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/customer-survey",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          meta: {
            requiresAuth: true,
            title: "Customer Satisfaction Survey"
          },
          children: [
            {
              path: "",
              name: CUSTOMER_SURVEY.BROWSE,
              component: CustomerSatisfactionSurvey,
              meta: {
                requiresAuth: true,
                title: "Customer Satisfaction Survey List",
                privilege: CUSTOMER_SURVEY.BROWSE
              }
            },
            {
              path: ":surveyId",
              component: {
                render(c) {
                  return c("router-view");
                }
              },
              meta: {
                requiresAuth: true,
                title: "Customer Satisfaction Survey Detail",
                bcDynamic: true,
                bcType: "survey-detail"
              },
              children: [
                {
                  path: "",
                  name: CUSTOMER_SURVEY.DETAIL,
                  component: CustomerSatisfactionSurveyDetail,
                  meta: {
                    requiresAuth: true,
                    title: "Customer Satisfaction Survey Detail",
                    privilege: CUSTOMER_SURVEY.BROWSE
                  }
                }
              ]
            }
          ]
        },
        {
          path: "/page-404",
          name: ERROR_PAGE.PAGE404_CONTENT,
          component: Page404
        },
        {
          path: "/page-500",
          name: ERROR_PAGE.PAGE500_CONTENT,
          component: Page500
        },
        {
          path: "/page-503",
          name: ERROR_PAGE.PAGE503_CONTENT,
          component: Page503
        }
      ]
    },
    {
      path: "/login",
      name: LOGIN,
      component: Login
    },
    // {
    //   path: '/reset-password',
    //   name: 'reset.password',
    //   component: ResetPassword
    // },
    {
      path: "/404",
      name: ERROR_PAGE.PAGE404,
      component: Page404
    },
    {
      path: "/500",
      name: ERROR_PAGE.PAGE500,
      component: Page500
    },
    {
      path: "/503",
      name: ERROR_PAGE.PAGE503,
      component: Page503
    }
  ];
};
